package com.raouf.mehrguard.web.i18n

internal val SpanishStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "Detector de QRishing Kotlin Multiplataforma",
    WebStringKey.MenuMain to "Menú principal",
    WebStringKey.MenuSecurity to "Seguridad",
    WebStringKey.MenuSystem to "Sistema",
    WebStringKey.NavDashboard to "Panel",
    WebStringKey.NavScanMonitor to "Monitor de escaneo",
    WebStringKey.NavScanHistory to "Historial de escaneo",
    WebStringKey.NavTrustCentre to "Centro de confianza",
    WebStringKey.NavReports to "Informes",
    WebStringKey.NavTraining to "Entrenamiento",
    WebStringKey.NavSettings to "Configuración",
    WebStringKey.QuickActions to "Acciones Rápidas",

    // Hero Section
    WebStringKey.HeroTagline to "Seguro. Sin conexión.",
    WebStringKey.HeroTagline2 to "Defensa Explicable.",
    WebStringKey.HeroDescription to "Mehr Guard analiza amenazas potenciales directamente en su hardware. Experimente protección sin latencia.",
    
    // Dashboard
    WebStringKey.StartScan to "Iniciar nuevo escaneo",
    WebStringKey.ImportImage to "Importar imagen",
    WebStringKey.ScanQrCode to "Escanear Código QR",
    WebStringKey.SystemHealth to "Salud del sistema",
    WebStringKey.ThreatDatabase to "Base de datos de amenazas",
    WebStringKey.Current to "Actual",
    WebStringKey.Active to "Activo",
    WebStringKey.Threats to "Amenazas",
    WebStringKey.SafeScans to "Escaneos seguros",
    WebStringKey.EngineActive to "Motor activo",
    WebStringKey.EnterpriseProtection to "Protección empresarial activa",
    WebStringKey.SystemOptimal to "Sistema Óptimo",
    WebStringKey.EngineStatus to "Motor v2.4 • Actualizado hace 2h",
    WebStringKey.ThreatsBlocked to "Amenazas Bloqueadas",
    WebStringKey.AllSystemsOperational to "Todos los sistemas operativos",

    // Dashboard Sections
    WebStringKey.SectionOverview to "Resumen",
    WebStringKey.SectionSecurity to "Seguridad",
    WebStringKey.SectionTraining to "Entrenamiento",
    WebStringKey.SectionReports to "Informes",
    WebStringKey.OfflineReady to "Listo sin conexión",
    WebStringKey.OfflineDescription to "Base de datos local v2.4.1 activa. No salen datos de este dispositivo.",
    
    // Trust Centre
    WebStringKey.TrustCentreTitle to "Centro de Confianza",
    WebStringKey.OfflineGuarantee to "Garantía Estricta Sin Conexión",
    WebStringKey.OfflineGuaranteeDesc to "El análisis de Mehr Guard se ejecuta completamente en el Neural Engine de su dispositivo. Los datos de URL nunca salen de su teléfono.",
    WebStringKey.ThreatSensitivity to "Sensibilidad de Amenazas",
    WebStringKey.ResetConfirm to "Esto restablecerá todas las configuraciones del Centro de Confianza a los valores predeterminados.",
    
    // Settings Quick Actions
    WebStringKey.ThreatMonitor to "Monitor de Amenazas",
    WebStringKey.ThreatMonitorDesc to "Ver amenazas en vivo y ejecutar auditoría de seguridad",
    WebStringKey.TrustCentreDesc to "Configuración de privacidad y sensibilidad de amenazas",
    WebStringKey.ExportReport to "Exportar Informe",
    WebStringKey.ExportReportDesc to "Generar informe de seguridad PDF o JSON",

    // Dashboard Content
    WebStringKey.Analyze to "Analizar",
    WebStringKey.HeuristicEngine to "Motor Heurístico",
    WebStringKey.HighPerformanceEngine to "Motor de Alto Rendimiento",
    WebStringKey.RecentScans to "Escaneos Recientes",
    WebStringKey.ViewFullHistory to "Ver Historial Completo",
    WebStringKey.Status to "Estado",
    WebStringKey.Source to "Fuente",
    WebStringKey.Details to "Detalles",
    WebStringKey.Time to "Hora",
    WebStringKey.Version to "Versión",
    WebStringKey.LastUpdate to "Última Actualización",
    WebStringKey.Signatures to "Firmas",
    WebStringKey.CheckForUpdates to "Buscar Actualizaciones",
    WebStringKey.FeatureOfflineTitle to "Arquitectura Offline-First",
    WebStringKey.FeatureOfflineDesc to "El análisis completo se realiza localmente. Su transmisión de cámara y datos escaneados nunca tocan un servidor externo, garantizando privacidad absoluta.",
    WebStringKey.FeatureExplainableTitle to "Seguridad Explicable",
    WebStringKey.FeatureExplainableDesc to "No obtenga solo un \"Bloqueo\". Proporcionamos desgloses heurísticos detallados de parámetros URL, redirecciones y cargas útiles de Javascript.",
    WebStringKey.FeaturePerformanceDesc to "Optimizado para entornos de escritorio. Los escaneos se procesan en menos de 5ms utilizando binarios nativos de Kotlin Multiplatform.",
    WebStringKey.TrainingCentre to "Centro de Entrenamiento",
    WebStringKey.LearnHomograph to "Aprende a identificar ataques avanzados de homógrafos QR.",
    WebStringKey.BeatTheBotAction to "Vence al Bot →",
    WebStringKey.NoScansYet to "Aún no hay escaneos. Inicie un nuevo escaneo para ver los resultados aquí.",
    WebStringKey.VerdictSafe to "SEGURO",
    WebStringKey.VerdictPhish to "PHISHING",
    WebStringKey.VerdictWarn to "ADVERTENCIA",
    WebStringKey.ScoreLabel to "Puntuación:",

    // Scanner
    WebStringKey.ActiveScanner to "Escáner Activo",
    WebStringKey.OfflineMode to "Modo Fuera de Línea",
    WebStringKey.LiveFeedDisconnected to "TRANSMISIÓN EN VIVO DESCONECTADA",
    WebStringKey.CameraAccessRequired to "Acceso a Cámara Requerido",
    WebStringKey.CameraAccessDescription to "Arrastra una imagen de código QR aquí o habilita el acceso a la cámara para comenzar a escanear.",
    WebStringKey.EnableCamera to "Habilitar Cámara",
    WebStringKey.Scanning to "Escaneando...",
    WebStringKey.ScanHint to "Manténlo quieto. Analizado sin conexión en <5ms.",
    WebStringKey.Torch to "Linterna",
    WebStringKey.Gallery to "Galería",
    WebStringKey.PasteUrl to "Pegar URL",
    WebStringKey.PasteUrlTitle to "Pegar URL para Analizar",
    WebStringKey.AnalyzeUrl to "Analizar URL",
    WebStringKey.SystemStatus to "Estado del Sistema",
    WebStringKey.PhishingEngine to "Motor de Phishing",
    WebStringKey.Ready to "LISTO",
    WebStringKey.LocalDb to "Base de Datos Local",
    WebStringKey.Latency to "Latencia",
    WebStringKey.ViewAll to "Ver Todo",

    // Threat / Results
    WebStringKey.BreadcrumbHome to "Inicio",
    WebStringKey.BreadcrumbScans to "Escaneos",
    WebStringKey.OfflineProtection to "Protección Fuera de Línea",
    WebStringKey.VerdictHighRisk to "ALTO RIESGO DETECTADO",
    WebStringKey.VerdictDangerous to "Peligroso",
    WebStringKey.VerdictDangerousDesc to "El código QR escaneado contiene indicadores maliciosos asociados con phishing y robo de credenciales. No continúe a la URL de destino.",
    WebStringKey.ThreatConfidence to "Confianza de Amenaza",
    WebStringKey.FlagPhishing to "Intento de Phishing",
    WebStringKey.FlagObfuscated to "Script Ofuscado",
    WebStringKey.FlagHomograph to "Ataque Homógrafo",
    WebStringKey.ClearHistory to "Borrar Todo",
    WebStringKey.SectionAttackBreakdown to "Desglose del Ataque",
    WebStringKey.AttackHomographTitle to "Ataque Homógrafo / IDN",
    WebStringKey.AttackHomographDesc to "Caracteres cirílicos imitando el alfabeto latino detectados.",
    WebStringKey.AttackVisualLabel to "Apariencia Visual",
    WebStringKey.AttackPunycodeLabel to "Punycode Real",
    WebStringKey.AttackHomographExplain to "El dominio utiliza el cirílico 'а' (U+0430) en lugar del latino 'a' (U+0061). Esta técnica se utiliza comúnmente para engañar a los usuarios haciéndoles creer que están visitando un servicio legítimo.",
    WebStringKey.AttackRedirectTitle to "Cadena de Redirección Sospechosa",
    WebStringKey.AttackRedirectDesc to "3 saltos detectados involucrando acortadores de URL conocidos.",
    WebStringKey.RedirectStart to "Escaneo de Código QR",
    WebStringKey.RedirectHop to "Salto Intermedio",
    WebStringKey.RedirectFinal to "Destino Final",
    WebStringKey.AttackJsTitle to "JavaScript Ofuscado",
    WebStringKey.AttackJsDesc to "Cadena de alta entropía detectada en parámetros de URL.",
    WebStringKey.SectionActions to "Acciones Recomendadas",
    WebStringKey.ActionBlock to "Bloquear y Reportar",
    WebStringKey.ActionBlockDesc to "Prevenir acceso y notificar al administrador",
    WebStringKey.ActionQuarantine to "Poner en Cuarentena",
    WebStringKey.ActionQuarantineDesc to "Abrir de forma segura para análisis",
    WebStringKey.Expected to "Esperado: ",
    WebStringKey.Detected to "Detectado: ",
    WebStringKey.ExplainableSecurity to "Seguridad Explicable",
    WebStringKey.UrlBreakdown to "DESGLOSE DE URL",
    WebStringKey.FullUrl to "URL COMPLETA",
    WebStringKey.OpenInBrowser to "Abrir en Navegador (Riesgoso)",
    WebStringKey.OpenWarning to "Abrir esta URL en su navegador puede exponerlo a riesgos de seguridad.",
    WebStringKey.RestrictedMode to "Modo Restringido",
    WebStringKey.RestrictedDesc to "Esta URL ha sido marcada como potencialmente peligrosa. Revise el análisis a continuación antes de continuar.",
    WebStringKey.DangerousWarning to "Esta URL ha sido marcada como potencialmente peligrosa. Abrirla puede exponerlo a phishing, malware u otras amenazas de seguridad. ¿Está seguro de que desea continuar?",
    WebStringKey.CopyUrl to "Copiar URL",
    WebStringKey.Share to "Compartir",
    WebStringKey.Dismiss to "Cerrar",
    WebStringKey.ReasonDomainAge to "Edad del dominio es menor a 24 horas.",
    WebStringKey.ReasonSignatures to "Coincidió con 3 firmas en la base de datos local de phishing.",
    WebStringKey.ReasonAsn to "La IP de destino se encuentra en un ASN de alto riesgo.",
    WebStringKey.SectionMeta to "Metadatos del Escaneo",
    WebStringKey.MetaTime to "Hora del Escaneo",
    WebStringKey.MetaSource to "Fuente",
    WebStringKey.MetaEngine to "Motor",
    WebStringKey.MetaOfflineGuaranteeLabel to "Garantía Fuera de Línea:",
    WebStringKey.MetaOfflineGuaranteeDesc to "Esta imagen fue analizada localmente en su dispositivo. No se enviaron datos a la nube para este veredicto.",
    
    // Results Page
    WebStringKey.ScanComplete to "Escaneo Completo",
    WebStringKey.Loading to "Cargando...",
    WebStringKey.AnalyzedOffline to "Analizado sin conexión en <5ms",
    WebStringKey.NoDataLeaves to "Los datos no salen del dispositivo",
    WebStringKey.ActiveProtection to "Protección Activa",
    WebStringKey.ConfidenceScore to "Puntuación de Confianza",
    WebStringKey.Analyzing to "ANALIZANDO...",
    WebStringKey.ProcessingResults to "Procesando resultados del escaneo...",
    WebStringKey.RiskAssessment to "Evaluación de Riesgo",
    WebStringKey.AnalysisTime to "Tiempo de Análisis",
    WebStringKey.Heuristics to "Heurísticas",
    WebStringKey.TopAnalysisFactors to "Principales Factores de Análisis",
    WebStringKey.Pass to "APROBADO",
    WebStringKey.Info to "INFO",
    WebStringKey.Clean to "LIMPIO",
    WebStringKey.ValidSslCertificate to "Certificado SSL Válido",
    WebStringKey.SslCertificateDesc to "Certificado emitido por DigiCert Inc. Sin anomalías en la cadena de confianza.",
    WebStringKey.EstablishedDomain to "Dominio Establecido",
    WebStringKey.EstablishedDomainDesc to "Dominio registrado hace > 5 años. Baja probabilidad de fraude.",
    WebStringKey.BlacklistStatus to "Estado de Lista Negra",
    WebStringKey.BlacklistStatusDesc to "No encontrado en 52 bases de datos de amenazas locales.",
    WebStringKey.BackToDashboard to "Volver al Panel",
    WebStringKey.ShareReport to "Compartir Informe",
    WebStringKey.CopyLink to "Copiar Enlace",
    WebStringKey.LinkCopied to "¡Enlace copiado al portapapeles!",
    
    // Game Page
    WebStringKey.BeatTheBot to "Vence al Bot",
    WebStringKey.BeatTheBotDesc to "Desafía nuestra IA sin conexión. ¿Puedes detectar el phishing más rápido?",
    WebStringKey.SessionId to "ID de Sesión",
    WebStringKey.EndSession to "Finalizar Sesión",
    WebStringKey.Round to "Ronda",
    WebStringKey.BrowserPreview to "Vista Previa del Navegador",
    WebStringKey.MakeDecision to "Toma tu decisión",
    WebStringKey.Phishing to "Suplantación",
    WebStringKey.Legitimate to "Legítimo",
    WebStringKey.LiveHint to "Pista en Vivo",
    WebStringKey.LiveScoreboard to "Marcador en Vivo",
    WebStringKey.VsMode to "MODO VS",
    WebStringKey.You to "Tú",
    WebStringKey.Points to "ptos",
    WebStringKey.Streak to "Racha",
    WebStringKey.Accuracy to "Precisión",
    WebStringKey.MehrGuardBot to "Bot Mehr Guard",
    WebStringKey.Confidence to "Confianza",
    WebStringKey.RoundAnalysis to "Análisis de Ronda",
    WebStringKey.Analysis to "Análisis",
    WebStringKey.CorrectDecision to "¡Decisión Correcta!",
    WebStringKey.IdentifiedSafe to "Identificaste correctamente la URL segura.",
    WebStringKey.AiNeuralAnalysis to "Análisis Neural IA",
    WebStringKey.WhyBotFlagged to "Por qué el bot lo marcó",
    WebStringKey.EducationalNote to "Nota Educativa",
    WebStringKey.Correct to "¡Correcto!",
    WebStringKey.SpottedPhishing to "Detectaste correctamente la URL de phishing.",
    WebStringKey.Response to "Respuesta",
    WebStringKey.NextRound to "Siguiente Ronda",
    WebStringKey.GameOver to "¡Juego Terminado!",
    WebStringKey.FinalResults to "Resultados Finales",
    WebStringKey.YourScore to "Tu Puntuación",
    WebStringKey.BotScore to "Puntuación del Bot",
    WebStringKey.BestStreak to "Mejor Racha",
    WebStringKey.PlayAgain to "Jugar de Nuevo",
    WebStringKey.ReturnToDashboard to "Volver al Panel",
    
    // Export Page
    WebStringKey.ExportSecurityReport to "Exportar Informe de Seguridad",
    WebStringKey.GenerateReport to "Genera informes de seguridad completos desde tu historial de escaneos.",
    WebStringKey.ReportFormat to "Formato de Informe",
    WebStringKey.HumanReadable to "Informe Legible",
    WebStringKey.HumanReadableDesc to "PDF con desglose visual y resumen ejecutivo",
    WebStringKey.MachineReadable to "Datos Legibles por Máquina",
    WebStringKey.MachineReadableDesc to "Formato JSON para integración SIEM",
    WebStringKey.DateRange to "Rango de Fechas",
    WebStringKey.Last7Days to "Últimos 7 Días",
    WebStringKey.Last30Days to "Últimos 30 Días",
    WebStringKey.Last90Days to "Últimos 90 Días",
    WebStringKey.AllTime to "Todo el Tiempo",
    WebStringKey.CustomRange to "Rango Personalizado",
    WebStringKey.ReportSections to "Secciones del Informe",
    WebStringKey.ExecutiveSummary to "Resumen Ejecutivo",
    WebStringKey.ThreatBreakdown to "Desglose de Amenazas",
    WebStringKey.ScanTimeline to "Línea de Tiempo de Escaneos",
    WebStringKey.SafeUrlList to "Lista de URLs Seguras",
    WebStringKey.GenerateExport to "Exportar Informe",
    
    // Toast / Notifications
    WebStringKey.Success to "¡Éxito!",
    WebStringKey.Error to "Fallo",
    WebStringKey.Warning to "Advertencia",
    WebStringKey.CopiedToClipboard to "Copiado al portapapeles",
    
    // General Actions
    WebStringKey.Cancel to "Cancelar",
    WebStringKey.Confirm to "Confirmar",
    WebStringKey.Save to "Guardar",
    WebStringKey.Delete to "Eliminar",
    WebStringKey.Edit to "Editar",
    WebStringKey.Close to "Cerrar",
    WebStringKey.Back to "Atrás",
    WebStringKey.Next to "Siguiente",
    WebStringKey.Previous to "Anterior",
    WebStringKey.Submit to "Enviar",
    WebStringKey.Reset to "Restablecer",
    WebStringKey.Clear to "Limpiar",
    WebStringKey.Search to "Buscar",
    WebStringKey.Filter to "Filtrar",
    WebStringKey.Sort to "Ordenar",
    
    // Accessibility
    WebStringKey.ToggleMenu to "Alternar menú",
    WebStringKey.ToggleTheme to "Alternar tema",
    WebStringKey.Notifications to "Notificaciones",
    WebStringKey.Help to "Ayuda",
    WebStringKey.Profile to "Perfil",
    WebStringKey.ToggleLightDarkMode to "Alternar modo claro/oscuro",
    
    // Placeholders
    WebStringKey.UrlInputPlaceholder to "Pega URL para analizar (ej: https://example.com)",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    
    // Export Page Additional
    WebStringKey.Scan to "Escaneo",
    WebStringKey.Result to "Resultado",
    WebStringKey.ReportGeneration to "Generación de Informe",
    WebStringKey.ReportGenerationDesc to "Configura formatos y descarga tu análisis de amenazas.",
    WebStringKey.OfflineSecurity to "Seguridad Sin Conexión",
    WebStringKey.OfflineSecurityDesc to "Tus datos nunca salen de este dispositivo. Todo el procesamiento es local.",
    WebStringKey.ChooseFormat to "Elegir Formato",
    WebStringKey.PdfFormatDesc to "Formato PDF. Ideal para compartir.",
    WebStringKey.JsonFormatDesc to "Formato JSON. Ideal para integración SIEM.",
    WebStringKey.Copy to "Copiar",
    WebStringKey.LivePreview to "Vista Previa en Vivo",
    WebStringKey.ReadOnly to "Solo Lectura",
    WebStringKey.ThreatAnalysisReport to "Informe de Análisis de Amenazas",
    WebStringKey.Verdict to "Veredicto",
    WebStringKey.RiskScore to "Puntuación de Riesgo",
    WebStringKey.TargetUrl to "URL Destino",
    WebStringKey.AnalysisSummaryLabel to "Resumen del Análisis",
    WebStringKey.TechnicalIndicators to "Indicadores Técnicos",
    WebStringKey.ExportInfoNote to "Las exportaciones incluyen todos los vectores de amenaza identificados y el análisis de carga útil.",
    
    // Trust Centre Page
    WebStringKey.AllowList to "Lista de Permitidos",
    WebStringKey.BlockList to "Lista de Bloqueo",
    WebStringKey.AddDomain to "Agregar Dominio",
    WebStringKey.RemoveDomain to "Eliminar Dominio",
    WebStringKey.TrustedDomains to "Dominios de Confianza",
    WebStringKey.BlockedDomains to "Dominios Bloqueados",
    WebStringKey.DomainPlaceholder to "Ingresa dominio (ej: example.com)",
    
    // Game Page Additional
    WebStringKey.Safe to "Seguro",
    WebStringKey.TimeAgo to "hace",
    WebStringKey.MinutesAgo to "mins atrás",
    WebStringKey.HoursAgo to "hrs atrás",
    
    // Misc
    WebStringKey.Critical to "CRÍTICO",
    WebStringKey.Warn to "ADVERTENCIA",
    
    // Trust Centre - Sensitivity
    WebStringKey.PhishingDetectionSensitivity to "Sensibilidad de Detección de Phishing",
    WebStringKey.SensitivityDescription to "Ajusta umbrales heurísticos. Mayor sensibilidad puede aumentar falsos positivos.",
    WebStringKey.SensitivityLow to "Bajo",
    WebStringKey.SensitivityBalanced to "Equilibrado",
    WebStringKey.SensitivityParanoia to "Máxima",
    WebStringKey.BalancedModeRecommended to "Modo Equilibrado (Recomendado)",
    WebStringKey.BalancedModeDesc to "Busca patrones maliciosos conocidos y discrepancias heurísticas. Bloquea ataques de homógrafos y cadenas de redirección.",
    WebStringKey.LowSensitivityMode to "Modo de Sensibilidad Baja",
    WebStringKey.LowSensitivityModeDesc to "Solo bloquea URLs maliciosas conocidas de la base de datos de amenazas. Mínimos falsos positivos, pero puede perder ataques nuevos.",
    WebStringKey.ParanoiaMode to "Modo Paranoia",
    WebStringKey.ParanoiaModeDesc to "Protección máxima. Bloquea cualquier patrón sospechoso incluyendo dominios recién registrados, TLDs poco comunes y cualquier URL con posibles trucos de codificación.",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard utiliza motores de análisis heurístico locales. Ningún dato de imagen, cadena de URL o metadatos abandona este dispositivo durante el escaneo. Su privacidad está matemáticamente garantizada.",
    WebStringKey.SignalBrandImpersonation to "Posible suplantación de marca detectada",
    WebStringKey.SignalCredentialParams to "Parámetros relacionados con credenciales en URL",
    WebStringKey.SignalEncodedPayload to "Datos codificados detectados en parámetros de consulta",
    WebStringKey.SignalExcessiveSubdomains to "Profundidad excesiva de subdominios ({count} niveles)",
    WebStringKey.SignalHighEntropyHost to "Alta aleatoriedad en nombre de dominio",
    WebStringKey.SignalHomographAttack to "El dominio contiene caracteres homógrafos/confundibles",
    WebStringKey.SignalHttpNotHttps to "Usa protocolo HTTP inseguro",
    WebStringKey.SignalIpAddressHost to "El host es una dirección IP en lugar de dominio",
    WebStringKey.SignalLongUrl to "URL inusualmente larga ({length} caracteres)",
    WebStringKey.SignalLongUrlMarketing to "URL inusualmente larga ({length} caracteres) - contiene parámetros de marketing",
    WebStringKey.SignalNewlyRegisteredDomain to "Dominio recién registrado detectado",
    WebStringKey.SignalNonStandardPort to "Puerto no estándar: {port}",
    WebStringKey.SignalNumericSubdomain to "Subdominio solo numérico detectado",
    WebStringKey.SignalSuspiciousPathKeywords to "Palabras clave sospechosas en ruta ({count} encontradas)",
    WebStringKey.SignalSuspiciousTld to "TLD sospechoso: {tld}",
    WebStringKey.SignalUrlShortener to "Usa servicio de acortamiento de URL",
    WebStringKey.SecureEnvironment to "Entorno Seguro",
    WebStringKey.LearnLocalArchitecture to "Conoce nuestra arquitectura local",
    WebStringKey.NoCustomDomainsBlocked to "No hay dominios personalizados bloqueados.",
    WebStringKey.AddManually to "Agregar manualmente",
    WebStringKey.AddedDaysAgo to "Agregado hace 2 días",
    WebStringKey.AddedWeekAgo to "Agregado hace 1 semana",
    
    // Trust Centre - Privacy Controls
    WebStringKey.PrivacyControls to "Controles de Privacidad",
    WebStringKey.StrictOfflineMode to "Modo Sin Conexión Estricto",
    WebStringKey.DisableExternalPreviews to "Deshabilitar todas las vistas previas de enlaces externos.",
    WebStringKey.AnonymousTelemetry to "Telemetría Anónima",
    WebStringKey.ShareDetectionStats to "Compartir estadísticas de detección para mejorar ML.",
    WebStringKey.AutoCopySafeLinks to "Copiar Enlaces Seguros Automáticamente",
    WebStringKey.CopyTrustedUrls to "Copiar URLs de confianza al portapapeles.",
    
    // Trust Centre - About
    WebStringKey.AboutMehrGuard to "Acerca de Mehr Guard",
    WebStringKey.OpenSourceLicenses to "Licencias de Código Abierto",
    WebStringKey.PrivacyPolicy to "Política de Privacidad",
    WebStringKey.Acknowledgements to "Agradecimientos",
    WebStringKey.ResetAllSettings to "Restablecer todas las configuraciones",
    WebStringKey.AddToAllowlist to "Agregar a Lista de Permitidos",
    WebStringKey.AddToBlocklist to "Agregar a Lista de Bloqueo",
    
    // Onboarding
    WebStringKey.AnalysedOfflineTitle to "Analizado sin conexión.",
    WebStringKey.YourDataStaysOnDevice to "Tus datos permanecen en el dispositivo.",
    WebStringKey.OnboardingHeroDesc to "Mehr Guard procesa cada escaneo con análisis seguro en el dispositivo. Priorizamos la seguridad explicable sin telemetría en la nube.",
    WebStringKey.OnDeviceAnalysis to "Análisis en el Dispositivo",
    WebStringKey.OnDeviceAnalysisDesc to "Toda la detección de amenazas se ejecuta localmente en tu dispositivo. Ningún dato sale de tu sistema.",
    WebStringKey.NoCloudLogs to "Sin Registros en la Nube",
    WebStringKey.NoCloudLogsDesc to "Deshabilitamos estrictamente la telemetría saliente para escaneos. Los resultados y hashes permanecen locales.",
    WebStringKey.OnDeviceDB to "Base de Datos en el Dispositivo",
    WebStringKey.OnDeviceDBDesc to "La base de datos completa de firmas de amenazas se descarga a tu dispositivo para búsquedas en milisegundos.",
    WebStringKey.DataLifecycleVerification to "Verificación del Ciclo de Vida de Datos",
    WebStringKey.SecurityAuditPass to "Auditoría de Seguridad: APROBADA",
    
    // Footer
    WebStringKey.Copyright to "© 2025-2026 Mehr Guard Security Inc. Todos los derechos reservados.",
    WebStringKey.Support to "Soporte",
    WebStringKey.Terms to "Términos",
    WebStringKey.SystemsOperational to "Sistemas Operativos",
    WebStringKey.SystemSecure to "Sistema Seguro",
    
    // Version / Build Info
    WebStringKey.VersionStatus to "v2.4.1 • Sistema Seguro",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2024.12.19",
    WebStringKey.VerifiedBy to "Verificado por Mehr Guard Enterprise",
    
    // User Profile (Sample)
    WebStringKey.SampleUserName to "Juan García",
    WebStringKey.SampleUserRole to "Analista de Seguridad",
    
    // Export Preview
    WebStringKey.DetailLabel to "Etiqueta de Detalle",
    WebStringKey.DetailValue to "Valor de Detalle",
    WebStringKey.Suspicious to "Sospechoso",
    
    // Game Modal Strings
    WebStringKey.IncorrectDecision to "Decisión Incorrecta",
    WebStringKey.WrongAnswer to "¡Ups! Eso no fue correcto.",
    WebStringKey.ResponseTime to "Tiempo de Respuesta",
    WebStringKey.IncomingMessage to "Mensaje Entrante",
    WebStringKey.CertificateIssuer to "Emisor del certificado coincide con el propietario del dominio",
    WebStringKey.DomainAgeTrust to "Edad del dominio > 5 años (Alta confianza)",
    WebStringKey.WhitelistedRank to "Top 1k de Alexa en lista blanca local",
    
    // Game Tips/Hints
    WebStringKey.GameEducationalNote to "Nota Educativa",
    WebStringKey.GameHintTitle to "Pista del Juego",
    
    // Trust Modal
    WebStringKey.AddToAllowlistTitle to "Agregar a Lista de Permitidos",
    WebStringKey.AddToBlocklistTitle to "Agregar a Lista de Bloqueo",
    WebStringKey.EnterDomainPrompt to "Ingresa un dominio para agregar a tu lista",
    
    // Additional Game Strings
    WebStringKey.LatencyMs to "Latencia",
    WebStringKey.StreakFire to "Racha",
    WebStringKey.AccuracyPercent to "Precisión",
    WebStringKey.ConfidencePercent to "Confianza",
    
    // Languages
    WebStringKey.English to "Inglés",
    WebStringKey.German to "Alemán",
    WebStringKey.Spanish to "Español",
    WebStringKey.French to "Francés",
    WebStringKey.ChineseSimplified to "Chino (Simplificado)",
    WebStringKey.Japanese to "Japonés",
    WebStringKey.Hindi to "Hindú",
    WebStringKey.Arabic to "Árabe",
    WebStringKey.Indonesian to "Indonesio",
    WebStringKey.Italian to "Italiano",
    WebStringKey.Korean to "Coreano",
    WebStringKey.Portuguese to "Portugués",
    WebStringKey.Russian to "Ruso",
    WebStringKey.Thai to "Tailandés",
    WebStringKey.Turkish to "Turco",
    WebStringKey.Vietnamese to "Vietnamita"
,
    WebStringKey.ComponentVoting to "Votación de Componentes",
    WebStringKey.Heuristic to "Heurística",
    WebStringKey.MLModel to "Modelo ML",
    WebStringKey.Brand to "Marca",
    WebStringKey.TLD to "TLD",
    WebStringKey.VotingExplanation to "El voto mayoritario determina el veredicto: 3+ SEGURO = verde, 2+ MALICIOSO = rojo"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "Esperando escaneo...",
    WebStringKey.WaitingForAnalysis to "Esperando análisis...",
    WebStringKey.ScanURLToSeeResults to "Escanea una URL para ver resultados detallados.",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "Atajos de Teclado",
    WebStringKey.StartScanner to "Iniciar Escáner",
    WebStringKey.CloseMenuModal to "Cerrar Menú / Modal",
    WebStringKey.NavigateToDashboard to "Ir al Panel",
    WebStringKey.NavigateToHistory to "Historial de Escaneo",
    WebStringKey.NavigateToTrust to "Centro de Confianza / Lista de Permitidos",
    WebStringKey.NavigateToGame to "Juego Vence al Bot",
    WebStringKey.ShowHelp to "Mostrar Ayuda",
    WebStringKey.GotIt to "Entendido",
    WebStringKey.SecuritySettings to "Configuración de Seguridad",
    WebStringKey.SensitivityLevel to "Nivel de Sensibilidad",
    WebStringKey.AutoBlockThreats to "Bloquear Amenazas Automáticamente",
    WebStringKey.RealTimeScanning to "Escaneo en Tiempo Real",
    WebStringKey.SoundAlerts to "Alertas Sonoras",
    WebStringKey.ThreatAlerts to "Alertas de Amenazas",
    WebStringKey.ShowConfidenceScore to "Mostrar Puntuación de Confianza",
    WebStringKey.CompactView to "Vista Compacta",
    WebStringKey.ResetDefaults to "Restablecer Valores Predeterminados",
    WebStringKey.SaveAndContinue to "Guardar y Continuar",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "Acerca de Mehr Guard Security",
    WebStringKey.ActualDomain to "Dominio real",
    WebStringKey.AnalysisComplete to "Análisis completo",
    WebStringKey.AutoBlockThreatsDesc to "Bloquear amenazas automáticamente",
    WebStringKey.AwaitingScanLabel to "Esperando escaneo",
    WebStringKey.BrandImpersonation to "Suplantación de marca",
    WebStringKey.CautionAdvised to "Se recomienda precaución",
    WebStringKey.CompactViewDesc to "Vista compacta",
    WebStringKey.DoNotVisit to "NO VISITAR",
    WebStringKey.DoNotVisitDesc to "Phishing de alta confianza detectado. Esta URL muestra múltiples indicadores maliciosos.",
    WebStringKey.DomainUsesInternationalChars to "Este dominio usa caracteres internacionales que pueden imitar dominios legítimos.",
    WebStringKey.GoToScanner to "Ir al escáner",
    WebStringKey.Hebrew to "Hebreo",
    WebStringKey.HelpKeyboardShortcuts to "Atajos de teclado",
    WebStringKey.HeuristicAnalysis to "Análisis heurístico",
    WebStringKey.HeuristicAnalysisDesc to "URL marcada según múltiples factores de riesgo detectados por el motor de análisis.",
    WebStringKey.HiddenDestination to "Destino oculto",
    WebStringKey.HighRisk to "Alto riesgo",
    WebStringKey.HighRiskLabel to "ALTO RIESGO",
    WebStringKey.HomographIdnAttack to "Ataque homógrafo / IDN",
    WebStringKey.InternationalizedDomainDetected to "Nombre de dominio internacionalizado detectado.",
    WebStringKey.JustNow to "Ahora mismo",
    WebStringKey.KeyboardShortcutsDesc to "Atajos de teclado para acceso rápido",
    WebStringKey.LiveFeedActive to "FEED EN VIVO ACTIVO",
    WebStringKey.LowRisk to "Bajo riesgo",
    WebStringKey.LowRiskLabel to "BAJO RIESGO",
    WebStringKey.Malicious to "Malicioso",
    WebStringKey.MediumRiskLabel to "RIESGO MEDIO",
    WebStringKey.NoData to "SIN DATOS",
    WebStringKey.NoScanDataResults to "No hay datos de escaneo disponibles. Escanee una URL para ver los resultados del análisis.",
    WebStringKey.NoUrlScanned to "No se escaneó URL",
    WebStringKey.Persian to "Persa",
    WebStringKey.PhishingIndicators to "Indicadores de phishing",
    WebStringKey.ProceedWithCaution to "PROCEDER CON PRECAUCIÓN",
    WebStringKey.ProceedWithCautionDesc to "Se detectaron algunos indicadores sospechosos. Verifique la fuente antes de ingresar información sensible.",
    WebStringKey.RealTimeScanningDesc to "Escaneo en tiempo real",
    WebStringKey.RedirectShortenerDetected to "Redirección/acortador detectado",
    WebStringKey.SafeToVisit to "SEGURO PARA VISITAR",
    WebStringKey.SafeToVisitDesc to "Verificado por heurísticas locales v2.4. No se encontraron patrones de phishing, scripts ofuscados ni coincidencias de lista negra.",
    WebStringKey.SafetyScore to "Puntuación de seguridad",
    WebStringKey.ScanCompleteLabel to "Escaneo completo",
    WebStringKey.ScanToAnalyze to "Escanee un código QR o ingrese una URL para analizar.",
    WebStringKey.ScannedURLLabel to "URL escaneada",
    WebStringKey.SecuritySignal to "Señal de seguridad",
    WebStringKey.SensitivityLevelDesc to "Nivel de sensibilidad",
    WebStringKey.SensitivityPermissive to "Permisivo",
    WebStringKey.SensitivityStrict to "Estricto",
    WebStringKey.SettingsDetection to "Detección",
    WebStringKey.SettingsDisplay to "Visualización",
    WebStringKey.SettingsLanguage to "Idioma",
    WebStringKey.SettingsLanguageDesc to "Seleccionar idioma de la interfaz",
    WebStringKey.SettingsNotifications to "Notificaciones",
    WebStringKey.SettingsSavedAutomatically to "Los ajustes se guardan automáticamente y se sincronizan entre sesiones.",
    WebStringKey.ShowConfidenceScoreDesc to "Mostrar puntuación de confianza",
    WebStringKey.SoundAlertsDesc to "Alertas sonoras",
    WebStringKey.SuspiciousDomain to "Dominio sospechoso",
    WebStringKey.SuspiciousEncoding to "Codificación sospechosa",
    WebStringKey.SuspiciousKeywords to "Palabras clave sospechosas",
    WebStringKey.SuspiciousTld to "TLD sospechoso",
    WebStringKey.SuspiciousTldDesc to "El dominio usa {tld} TLD comúnmente asociado con sitios maliciosos.",
    WebStringKey.SuspiciousUrlParams to "Parámetros de URL sospechosos",
    WebStringKey.SuspiciousUrlParamsDesc to "La URL contiene parámetros complejos o potencialmente ofuscados.",
    WebStringKey.ThreatAlertsDesc to "Alertas de amenazas",
    WebStringKey.ThreatDetected to "Amenaza detectada",
    WebStringKey.UnableToDetermine to "No se pudo determinar el veredicto. Intente de nuevo.",
    WebStringKey.Unknown to "Desconocido",
    WebStringKey.UnknownURL to "URL desconocida",
    WebStringKey.UrlShortenerDesc to "La URL usa un servicio de acortamiento que oculta el destino final.",
    WebStringKey.UrlShortenerDetected to "Acortador de URL detectado",
    WebStringKey.VersionOfflineReady to "Listo para offline",
    WebStringKey.VisualAppearance to "Apariencia visual",
    WebStringKey.WaitingForAnalysisLabel to "Esperando análisis..."
)

internal val SpanishCommonStrings = mapOf(
    "\"Always expand short links before scanning. The bot does this automatically by following redirect headers without rendering the page.\"" to "\"Siempre expanda los enlaces cortos antes de escanear. El bot lo hace automáticamente siguiendo los encabezados de redireccionamiento sin mostrar la página\".",
    "\"AusPost: Your parcel failed delivery due to incorrect address details. Please update immediately via the link above to avoid return.\"" to "\"AusPost: Su paquete no se pudo entregar debido a detalles de dirección incorrectos. Actualice inmediatamente a través del enlace de arriba para evitar la devolución\".",
    "\"Commonwealth Bank: Your account has been locked due to suspicious activity. Verify your identity immediately.\"" to "\"Commonwealth Bank: Su cuenta ha sido bloqueada debido a actividad sospechosa. Verifique su identidad de inmediato\".",
    "\"Let's Encrypt (R3)\"" to "\"Cifremos (R3)\"",
    "\"Phishing\"" to "\"phishing\"",
    "\"You won a \$500 gift card! Click to claim your prize.\"" to "\"¡Ganaste una tarjeta de regalo de \$500! Haz clic para reclamar tu premio\".",
    "\"Your Apple ID was used to sign in on a new device. If this was not you, verify immediately.\"" to "\"Su ID de Apple se utilizó para iniciar sesión en un nuevo dispositivo. Si no era usted, verifíquelo de inmediato\".",
    "\"Your PayPal account has been limited. Please update your information.\"" to "\"Su cuenta PayPal ha sido limitada. Actualice su información\".",
    "+10-15 points — Context-dependent signal" to "+10-15 puntos: señal dependiente del contexto",
    "+10-15 points — Suggestive but not conclusive" to "+10-15 puntos: sugerente pero no concluyente",
    "+10-15 points — Suspicious but not definitive" to "+10-15 puntos: sospechoso pero no definitivo",
    "+10-20 points — Contributes to overall risk score" to "+10-20 puntos: contribuye a la puntuación de riesgo general",
    "+15-20 points — Requires caution, not definitive" to "+15-20 puntos: requiere precaución, no es definitivo",
    "+15-20 points — Requires destination inspection" to "+15-20 puntos: requiere inspección en destino",
    "+15-20 points — Security baseline not met" to "+15-20 puntos: no se cumple la línea base de seguridad",
    "+20-30 points — Deliberate deception technique" to "+20-30 puntos — Técnica de engaño deliberada",
    "+20-30 points — Legitimate brands rarely use these" to "+20-30 puntos: las marcas legítimas rara vez los utilizan",
    "+25-30 points — Strong phishing indicator" to "+25-30 puntos: fuerte indicador de phishing",
    "+30-35 points — Requires investigation of actual characters" to "+30-35 puntos: requiere investigación de personajes reales",
    "+30-40 points — This is a primary phishing indicator" to "+30-40 puntos: este es un indicador principal de phishing",
    "+40-50 points — Advanced attack requiring intentional deception" to "+40-50 puntos: ataque avanzado que requiere engaño intencional",
    "+5-10 points — Minor signal" to "+5-10 puntos — Señal menor",
    "- Heuristics: {list}" to "- Heurística: {list}",
    "- Redirects: {count}" to "- Redirecciones: {count}",
    "- SSL Issuer: {issuer}" to "- Emisor SSL: {issuer}",
    "- Threat Type: {type}" to "- Tipo de amenaza: {type}",
    "1 hr ago • Phishing" to "Hace 1 hora • Phishing",
    "100% offline" to "100% fuera de línea",
    "2 hours ago" to "hace 2 horas",
    "2 mins ago • Safe" to "Hace 2 minutos • Seguro",
    "25+ AI Heuristics" to "Más de 25 heurísticas de IA",
    "3 hops detected involving known URL shorteners." to "Se detectaron 3 saltos que involucran acortadores de URL conocidos.",
    "3 hrs ago • Safe" to "Hace 3 horas • Seguro",
    "350 pts" to "350 puntos",
    "400 pts" to "400 puntos",
    "5 hrs ago • Safe" to "Hace 5 horas • Seguro",
    "< 24 hours" to "< 24 horas",
    "A phishing attempt was successfully blocked" to "Un intento de phishing fue bloqueado exitosamente",
    "A shorter, cleaner URL would reduce this signal contribution by ~8 points." to "Una URL más corta y más limpia reduciría esta contribución de señal en aproximadamente 8 puntos.",
    "AD" to "ANUNCIO",
    "AI-powered phishing detection running 100% offline in your browser." to "Detección de phishing impulsada por IA que se ejecuta 100% sin conexión en su navegador.",
    "AI-powered phishing detection that runs" to "Detección de phishing impulsada por IA que se ejecuta",
    "AM" to "SOY",
    "About Mehr Guard" to "Acerca de [[MARCA]]",
    "Accuracy" to "Exactitud",
    "Accuracy:" to "Exactitud:",
    "Acknowledgements" to "Expresiones de gratitud",
    "Active" to "Activo",
    "Active Protection" to "Protección activa",
    "Active Scanner" to "Escáner activo",
    "Actual Punycode (Where it goes)" to "Punycode real (adónde va)",
    "Add Domain" to "Agregar dominio",
    "Add manually" to "Agregar manualmente",
    "Add to Allowlist" to "Agregar a la lista de permitidos",
    "Add to Blocklist" to "Agregar a la lista de bloqueo",
    "Added 1 week ago" to "Agregado hace 1 semana",
    "Added 2 days ago" to "Agregado hace 2 días",
    "Added {domain} to {list}" to "Se agregó {domain} a {list}",
    "Adjust heuristic thresholds. Higher sensitivity may increase false positives." to "Ajustar los umbrales heurísticos. Una mayor sensibilidad puede aumentar los falsos positivos.",
    "Alex Chen" to "Alex Chen",
    "Alex Morgan" to "Alex Morgan",
    "Alexa Top 1000 site" to "Sitio Top 1000 de Alexa",
    "All URLs will show as MALICIOUS for demo purposes" to "Todas las URL se mostrarán como MALICIOSAS para fines de demostración.",
    "All code execution happens in an ephemeral container that is destroyed after each scan. This ensures malicious payloads can never escape to your system." to "Toda la ejecución del código ocurre en un contenedor efímero que se destruye después de cada escaneo. Esto garantiza que las cargas útiles maliciosas nunca puedan escapar a su sistema.",
    "All notifications marked as read" to "Todas las notificaciones marcadas como leídas",
    "Allow List" to "Lista de permitidos",
    "Allowlist" to "Lista de permitidos",
    "Analysed offline." to "Analizado fuera de línea.",
    "Analysis" to "Análisis",
    "Analysis Complete" to "Análisis completo",
    "Analysis Engine Loading..." to "Motor de análisis Cargando...",
    "Analysis Summary" to "Resumen del análisis",
    "Analysis Time" to "Tiempo de análisis",
    "Analyze" to "Analizar",
    "Analyze This URL" to "Analizar esta URL",
    "Analyze URL" to "Analizar URL",
    "Analyzed offline in <5ms" to "Analizado sin conexión en <5 ms",
    "Analyzing offline..." to "Analizando sin conexión...",
    "Anonymous Telemetry" to "Telemetría anónima",
    "Anonymous Telemetry disabled" to "Telemetría anónima deshabilitada",
    "Anonymous Telemetry enabled" to "Telemetría anónima habilitada",
    "Apple Support" to "Soporte técnico de Apple",
    "Apple only uses apple.com for all account-related activities. Be wary of domains containing brand names but with different extensions." to "Apple sólo utiliza apple.com para todas las actividades relacionadas con la cuenta. Tenga cuidado con los dominios que contienen nombres de marcas pero con diferentes extensiones.",
    "Apple would never use a third-party domain for account verification. Check the actual domain name." to "Apple nunca utilizaría un dominio de terceros para verificar la cuenta. Verifique el nombre de dominio real.",
    "Are you sure you want to end this session? Progress will be lost." to "¿Estás seguro de que quieres finalizar esta sesión? Se perderá el progreso.",
    "Atlassian" to "Atlassiano",
    "Atlassian is a legitimate software company. Their primary domain atlassian.com is trustworthy." to "Atlassian es una empresa de software legítima. Su dominio principal atlassian.com es confiable.",
    "Attack Breakdown" to "Desglose del ataque",
    "Attackers create domains that look like trusted brands to steal credentials" to "Los atacantes crean dominios que parecen marcas confiables para robar credenciales",
    "Auto-Block Threats" to "Amenazas de bloqueo automático",
    "Auto-Copy Safe Links" to "Copia automática de enlaces seguros",
    "Auto-Copy Safe Links disabled" to "Copia automática de enlaces seguros deshabilitada",
    "Auto-Copy Safe Links enabled" to "Enlaces seguros de copia automática habilitados",
    "Automatically block high-risk URLs" to "Bloquear automáticamente URL de alto riesgo",
    "Back online" to "De nuevo en línea",
    "Back to Dashboard" to "Volver al panel",
    "Balanced" to "Equilibrado",
    "Balanced Mode (Recommended)" to "Modo equilibrado (recomendado)",
    "Beat the Bot" to "Vencer al Bot",
    "Beat the Bot →" to "Vencer al Bot →",
    "Best Streak" to "Mejor racha",
    "Blacklist Match" to "Partida de lista negra",
    "Blacklist Status" to "Estado de lista negra",
    "Block & Report" to "Bloquear e informar",
    "Blocklist" to "Lista de bloqueo",
    "Bot Score" to "Puntuación de bot",
    "Brand Impersonation" to "Suplantación de marca",
    "Brand Impersonation Detected" to "Marca Suplantación de identidad detectada",
    "Brands Detected" to "Marcas detectadas",
    "Browser Preview" to "Vista previa del navegador",
    "Built for" to "Creado para",
    "CLEAN" to "LIMPIO",
    "CRITICAL" to "CRÍTICO",
    "Camera API (QR scanning unavailable)" to "API de la cámara (escaneo QR no disponible)",
    "Camera Access Required" to "Se requiere acceso a la cámara",
    "Camera Not Available" to "Cámara no Disponible",
    "Camera activated" to "Cámara activada",
    "Camera error: {error}" to "Error de cámara: {error}",
    "Camera not supported in this browser" to "Cámara no compatible con este navegador",
    "Camera permission denied" to "Permiso de cámara denegado",
    "Can redirect through tracking or to malicious destinations" to "Puede redirigir a través de seguimiento o a destinos maliciosos",
    "Cancel" to "Cancelar",
    "Caution" to "Precaución",
    "Caution Advised" to "Precaución Aconsejado",
    "Certificate Issuer matches domain owner (DigiCert Inc)" to "El emisor del certificado coincide con el propietario del dominio (DigiCert Inc)",
    "Certificate Issuer matches domain owner (DigiCert Inc)." to "El emisor del certificado coincide con el propietario del dominio (DigiCert Inc).",
    "Certificate issued by DigiCert Inc. No anomalies in chain of trust." to "Certificado emitido por DigiCert Inc. No hay anomalías en la cadena de confianza.",
    "Certificate issued by trusted CA. No anomalies in chain of trust." to "Certificado emitido por una CA confiable. No hay anomalías en la cadena de confianza.",
    "Certificate recently issued or self-signed. Proceed with caution." to "Certificado emitido recientemente o autofirmado. Proceda con precaución.",
    "Challenge our offline AI engine. Can you spot the phish faster?" to "Desafía nuestro motor de IA fuera de línea. ¿Puedes detectar el phishing más rápido?",
    "Characters like Cyrillic \"а\" look identical to Latin \"a\" but are different" to "Caracteres como la \"а\" cirílica parecen idénticos a la \"a\" latina pero son diferentes",
    "Check for Updates" to "Buscar actualizaciones",
    "Check the domain carefully. This appears to be a well-known, trusted domain." to "Revisa el dominio cuidadosamente. Este parece ser un dominio confiable y conocido.",
    "Choose Format" to "Elegir formato",
    "Clear All" to "Borrar todo",
    "Clear History" to "Borrar historial",
    "Clear scan history?" to "¿Borrar historial de escaneo?",
    "Click a sample below or paste any URL:" to "Haga clic en una muestra a continuación o pegue cualquier URL:",
    "Close" to "Cerrar",
    "Code execution happens in an ephemeral container. Malicious payloads never touch your OS kernel." to "La ejecución del código ocurre en un contenedor efímero. Las cargas maliciosas nunca tocan el kernel de su sistema operativo.",
    "Combined with other signals, suggests intent to steal credentials" to "Combinado con otras señales, sugiere la intención de robar credenciales",
    "Compact View" to "Vista compacta",
    "Compact view" to "Vista compacta",
    "Complete analysis is performed locally. Your camera feed and scanned data never touch an external server, ensuring absolute privacy." to "El análisis completo se realiza localmente. La transmisión de su cámara y los datos escaneados nunca tocan un servidor externo, lo que garantiza una privacidad absoluta.",
    "Confidence Score" to "Puntuación de confianza",
    "Confidence score" to "Puntuación de confianza",
    "Confidence: 99.8%" to "Confianza: 99,8%",
    "Configure formats and download your threat analysis." to "Configure formatos y descargue su análisis de amenazas.",
    "Congratulations! You beat the bot!" to "¡Felicitaciones! ¡Le ganaste al robot!",
    "Continue Anyway" to "Continuar de todos modos",
    "Copy" to "Copiar",
    "Copy Link" to "Copiar enlace",
    "Copy trusted URLs to clipboard." to "Copiar URL confiables al portapapeles.",
    "Core v2.4.1 • Build 2024.12.19" to "Core v2.4.1 • Build 2024.12.19",
    "Correct Decision!" to "Correcto ¡Decisión!",
    "Correct!" to "¡Correcto!",
    "Could not save theme preference:" to "No se pudo guardar la preferencia del tema:",
    "Couldn\\'t Read QR Code" to "No se pudo leer el código QR",
    "Credential Harvesting Path" to "Ruta de recolección de credenciales",
    "Credential Harvesting Path (/login)" to "Ruta de recolección de credenciales (/login)",
    "Current" to "Actual",
    "Cyrillic characters mimicking Latin alphabet detected." to "Caracteres cirílicos que imitan el alfabeto latino detectado.",
    "DB CHECK" to "DB CHECK",
    "DISCONNECTED" to "DESCONECTADO",
    "DO NOT VISIT" to "NO VISITA",
    "DOMAIN" to "DOMINIO",
    "Dangerous" to "Peligroso",
    "Dark" to "Oscuro",
    "Dashboard" to "Panel de control",
    "Data Lifecycle Verification" to "Verificación del ciclo de vida de los datos",
    "Data Point" to "Datos Punto",
    "Data exported successfully!" to "¡Datos exportados correctamente!",
    "Data sent without encryption can be intercepted" to "Los datos enviados sin cifrado pueden ser interceptados",
    "Database Updated" to "Base de datos actualizada",
    "Decoded URL/Payload" to "URL decodificada/carga útil",
    "Deep subdomains can hide the actual domain at the end" to "Los subdominios profundos pueden ocultar el dominio real al final",
    "Destination URL obfuscated. Unable to verify final target." to "URL de destino ofuscada. No se puede verificar el objetivo final.",
    "Details" to "Detalles",
    "Detection" to "Detección",
    "Deutsch" to "Deutsch",
    "Disable all external link previews." to "Desactivar todas las vistas previas de enlaces externos.",
    "Display" to "Mostrar",
    "Display threat probability percentage" to "Mostrar porcentaje de probabilidad de amenaza",
    "Do Not Visit This URL" to "No visitar esta URL",
    "Domain \"apple-id-verify.com\" is not owned by Apple" to "Dominio \"apple-id-verify.com\" no es propiedad de Apple",
    "Domain age > 5 years (High trust)." to "Antigüedad del dominio > 5 años (alta confianza).",
    "Domain age is less than 24 hours." to "La antigüedad del dominio es inferior a 24 horas.",
    "Domain already in list" to "El dominio ya está en la lista",
    "Domain contains \"xn--\" IDN encoding" to "El dominio contiene codificación IDN \"xn--\"",
    "Domain contains or mimics a known brand name (PayPal, Amazon, etc.)" to "El dominio contiene o imita una marca conocida (PayPal, Amazon, etc.)",
    "Domain mimics known brand (PayPal → Paypa1). High-confidence phishing." to "El dominio imita una marca conocida (PayPal → Paypa1). Phishing de alta confianza.",
    "Domain mimics legitimate bank (commbank.com.au)" to "El dominio imita un banco legítimo (commbank.com.au)",
    "Domain or path contains random-looking character sequences" to "El dominio o la ruta contiene secuencias de caracteres de apariencia aleatoria",
    "Domain registered > 5 years ago. Low probability of churn-and-burn." to "Dominio registrado hace > 5 años. Baja probabilidad de abandono y quema.",
    "Domain registered in the last 24 hours" to "Dominio registrado en las últimas 24 horas",
    "Domain uses common misspellings or character substitutions (paypa1, amaz0n)" to "El dominio utiliza errores ortográficos comunes o sustituciones de caracteres (paypa1, amaz0n)",
    "Domain uses suspicious hyphenated structure (verify-deliveries.net)" to "El dominio utiliza una estructura con guiones sospechosa (verify-deliveries.net)",
    "Don't just get a \"Block\". We provide detailed heuristic breakdowns of URL parameters, redirects, and javascript payloads." to "No se limite a obtener un \"Bloquear\". Proporcionamos desgloses heurísticos detallados de los parámetros de URL, redireccionamientos y cargas útiles de JavaScript.",
    "Download Apps" to "Descargar aplicaciones",
    "Drag & Drop QR code image here" to "Arrastre y suelte la imagen del código QR aquí",
    "Drag & drop a QR code image here or enable camera access to start scanning." to "Arrastre y suelte una imagen del código QR aquí o habilite el acceso a la cámara para comenzar a escanear.",
    "Educational Note" to "Nota educativa",
    "Embedded Redirect" to "Incrustado Redirigir",
    "Enable Camera" to "Habilitar cámara",
    "Enable camera first" to "Habilite la cámara primero",
    "End Session" to "Finalizar sesión",
    "Engine" to "Motor",
    "Engine Active" to "Motor activo",
    "Engine Active (Offline)" to "Motor activo (sin conexión)",
    "Engine initializing, please wait..." to "Motor inicializándose, espere...",
    "Engine initializing..." to "Motor inicializándose...",
    "Engine not ready, using demo mode" to "Motor no listo, usando demostración modo",
    "English" to "Inglés",
    "Enter" to "Ingresar",
    "Enter URL" to "Ingresar URL",
    "Enter URL Manually" to "Ingresar URL manualmente",
    "Enterprise Plan" to "Plan empresarial",
    "Enterprise Protection Active" to "Protección empresarial Activo",
    "Esc" to "Esc",
    "Escape" to "Escape",
    "Español" to "Español",
    "Established Domain" to "Dominio establecido",
    "Excessive Subdomains" to "Subdominios excesivos",
    "Excessively Long URL" to "URL excesivamente larga",
    "Exit" to "Salir",
    "Explainable Defence." to "Defensa explicable.",
    "Explainable Security" to "Explicable Seguridad",
    "Export" to "Exportar",
    "Export Report" to "Exportar informe",
    "Export Reports" to "Exportar informes",
    "Exports include all identified threat vectors, headers, and the raw payload analysis." to "Las exportaciones incluyen todos los vectores de amenazas identificados, encabezados y el análisis de carga útil sin procesar.",
    "External Transmission" to "Transmisión externa",
    "FAIL" to "FAIL",
    "Failed to copy link" to "Error al copiar el enlace",
    "Failed to copy report" to "Error al copiar informe",
    "Failed to get scan statistics:" to "No se pudieron obtener estadísticas de escaneo:",
    "Failed to load image" to "No se pudo cargar la imagen",
    "Failed to read file" to "No se pudo leer el archivo",
    "Failed to share" to "No se pudo compartir",
    "Failed to share report" to "No se pudo compartir el informe",
    "File upload (image scanning unavailable)" to "Carga de archivo (escaneo de imagen no disponible)",
    "Final Destination" to "Destino final",
    "Final Results" to "Final Resultados",
    "Fix it" to "Solucionarlo",
    "For the best experience, use Chrome, Firefox, Safari, or Edge." to "Para obtener la mejor experiencia, use Chrome, Firefox, Safari o Edge.",
    "Found in 3 local offline threat databases." to "Se encuentra en 3 bases de datos de amenazas locales fuera de línea.",
    "Français" to "Français",
    "Free/cheap TLDs are heavily abused for throwaway phishing domains" to "Se abusa mucho de los TLD gratuitos/baratos para el phishing desechable dominios",
    "Gallery" to "Galería",
    "Game Over!" to "¡Juego terminado!",
    "Generate Test QR" to "Generar QR de prueba",
    "Generate a test malicious QR code" to "Generar un código QR malicioso de prueba",
    "Generated on Dec 29, 2025 • 14:32:01 UTC" to "Generado el 24 de octubre de 2023 • 14:32:01 UTC",
    "Generated on {date} • {time} UTC" to "Generado el {date} • {time} UTC",
    "Generating {format} report..." to "Generando informe {format}...",
    "Get Started! 🚀" to "¡Comience! 🚀",
    "GitHub" to "GitHub",
    "GitHub.com is a legitimate developer platform owned by Microsoft. Always verify the exact domain spelling." to "GitHub.com es una plataforma de desarrollador legítima propiedad de Microsoft. Verifique siempre la ortografía exacta del dominio.",
    "Gmail" to "Gmail",
    "Google Docs" to "Google Docs",
    "Google Docs uses docs.google.com. Always verify the sender knows you before opening shared documents." to "Google Docs utiliza docs.google.com. Verifique siempre que el remitente lo conozca antes de abrir documentos compartidos.",
    "Google services use subdomains of google.com. mail.google.com is the legitimate Gmail address." to "Los servicios de Google utilizan subdominios de google.com. mail.google.com es la dirección legítima de Gmail.",
    "Got it" to "Entendido",
    "HIGH" to "ALTO",
    "HIGH RISK" to "ALTO RIESGO",
    "HIGH RISK DETECTED" to "ALTO RIESGO DETECTADO",
    "HTTP instead of HTTPS (no encryption)" to "HTTP en lugar de HTTPS (no cifrado)",
    "HTTPS" to "HTTPS",
    "Help" to "Ayuda",
    "Heuristic Engine" to "Motor heurístico",
    "Heuristics" to "Heurística",
    "Hides the true destination URL from the user" to "Oculta la verdadera URL de destino del usuario",
    "High" to "Alta",
    "High Entropy" to "Alta entropía",
    "High Risk" to "Alto riesgo",
    "High entropy string detected in URL parameters." to "Se detectó cadena de alta entropía en parámetros de URL.",
    "High-Performance Engine" to "Motor de alto rendimiento",
    "High-Risk TLD" to "TLD de alto riesgo",
    "High-Risk URL Blocked" to "URL de alto riesgo bloqueada",
    "High-confidence phishing detected. This URL exhibits multiple malicious indicators." to "phishing de alta confianza detectado. Esta URL muestra múltiples indicadores maliciosos.",
    "Hold steady. Analysed offline in <5ms." to "Manténgase firme. Analizado fuera de línea en <5ms.",
    "Home" to "Inicio",
    "Homograph / IDN Attack" to "Ataque homógrafo/IDN",
    "Homograph Attack" to "Ataque homógrafo",
    "Homograph attack: \"c0mmonwealth\" uses zero instead of letter O" to "Ataque homógrafo: \"c0mmonwealth\" usa cero en lugar de la letra O",
    "Homograph attack: \"paypa1\" uses number 1 instead of letter L" to "Ataque homógrafo: \"paypa1\" usa el número 1 en lugar de la letra L",
    "Homograph attacks use similar-looking characters. Always check URLs character by character for suspicious substitutions." to "Ataques homógrafo Utilice personajes de apariencia similar. Siempre verifique las URL carácter por carácter para detectar sustituciones sospechosas.",
    "How aggressive should threat detection be?" to "¿Qué tan agresiva debe ser la detección de amenazas?",
    "Human-Readable Report" to "Informe legible por humanos",
    "I am reporting a suspected phishing URL detected by Mehr Guard:" to "Estoy informando de una URL sospechosa de phishing detectada por Mehr Guard:",
    "ID: scan_2023_10_24_af92" to "ID: scan_2023_10_24_af92",
    "ID: {id}" to "ID: {id}",
    "INFO" to "INFO",
    "IP Address Host" to "Host de dirección IP",
    "If HTTPS was used, this signal would not trigger and score would drop by ~18 points." to "Si se usara HTTPS, esta señal no se activaría y la puntuación disminuiría ~18 puntos.",
    "If a registered domain name was used instead of IP address, score would drop by ~28 points." to "Si se usara un nombre de dominio registrado en lugar de una dirección IP, la puntuación disminuiría ~28 puntos.",
    "If all characters were ASCII Latin letters, this signal would not trigger and score would drop by ~45 points." to "Si todos los caracteres fueran letras latinas ASCII, esta señal no se activaría y la puntuación disminuiría ~45 puntos.",
    "If no embedded URLs were present in query parameters, score would drop by ~18 points." to "Si no hubiera URL incrustadas en los parámetros de consulta, la puntuación disminuiría en ~18 puntos.",
    "If only 1-2 subdomains were used, this signal would not trigger. Score would drop by ~12 points." to "Si solo se usaran 1 o 2 subdominios, esta señal no se activaría. La puntuación se reduciría en ~12 puntos.",
    "If the domain spelled the brand correctly without substitutions, score would drop by ~25 points." to "Si el dominio escribiera la marca correctamente sin sustituciones, la puntuación se reduciría en ~25 puntos.",
    "If the domain used only ASCII characters (no IDN), score would drop by ~32 points." to "Si el dominio usara solo caracteres ASCII (sin IDN), la puntuación se reduciría en ~32 puntos.",
    "If the domain used readable words instead of random characters, score would drop by ~12 points." to "Si el dominio usara palabras legibles en lugar de caracteres aleatorios, la puntuación se reduciría en ~12 puntos.",
    "If the full destination URL was visible, score would drop by ~18 points (assuming destination is safe)." to "Si la URL de destino completa fuera visible, la puntuación se reduciría en ~18 puntos (suponiendo que el destino sea seguro).",
    "If this URL used .com, .org, or country TLDs, score would drop by ~25 points." to "Si esta URL usara .com, .org o TLD de país, la puntuación se reduciría en ~25 puntos.",
    "If this were the official brand domain (paypal.com), this signal would not trigger and score would drop by ~35 points." to "Si este fuera el dominio oficial de la marca (paypal.com), esta señal no se activaría y la puntuación disminuiría ~35 puntos.",
    "Import Image" to "Importar imagen",
    "Imported: {name}" to "Importado: {name}",
    "Incoming Message (+61 491 570 010):" to "Mensaje entrante (+61 491 570 010):",
    "Incorrect Decision" to "Decisión incorrecta",
    "Intermediate Hop" to "Intermedio Hop",
    "International domains can hide malicious lookalike characters" to "Los dominios internacionales pueden ocultar caracteres maliciosos similares",
    "Invalid URL Format" to "Formato de URL no válido",
    "Invalid URL format" to "Formato de URL no válido",
    "Invalid theme:" to "Tema no válido:",
    "Isolated Sandbox" to "Sandbox aislado",
    "It's a Tie!" to "¡Es un empate!",
    "JS" to "JS",
    "JSON format. Best for SIEM integration." to "Formato JSON. Lo mejor para la integración SIEM.",
    "JSON report downloaded" to "Informe JSON descargado",
    "John Smith" to "John Smith",
    "Judge Mode" to "Modo de juez",
    "Judge Mode Active" to "Modo de juez activo",
    "Judge Mode OFF - Normal detection active" to "Modo de juez APAGADO - Detección normal activa",
    "Judge Mode: Force MALICIOUS results for demo" to "Modo de juez: forzar resultados MALICIOSOS para la demostración",
    "Judge Mode: ON" to "Modo de juez: ON",
    "Just now" to "Justo ahora",
    "Kotlin Multiplatform" to "Kotlin Multiplataforma",
    "Kotlin engine not ready yet" to "El motor Kotlin aún no está listo",
    "Kotlin/Wasm" to "Kotlin/Wasm",
    "KotlinConf Student Competition 2025-2026" to "Concurso de estudiantes KotlinConf 2025-2026",
    "LIVE" to "EN VIVO",
    "LIVE FEED ACTIVE" to "EN VIVO ACTIVO",
    "LIVE FEED DISCONNECTED" to "ALIMENTACIÓN EN VIVO DESCONECTADA",
    "LOW" to "BAJO",
    "LOW RISK" to "BAJO RIESGO",
    "Language: {language} {flag}" to "Idioma: {language} {flag}",
    "Last Update" to "Última actualización",
    "Latency" to "Latencia",
    "Latency: 2ms" to "Latencia: 2ms",
    "Learn about our local architecture" to "Conozca nuestra arquitectura local",
    "Learn how to identify advanced QR homograph attacks." to "Aprenda cómo identificar ataques homógrafos QR avanzados.",
    "Legitimate" to "Legítimo",
    "Legitimate services use domains; IPs hide identity and bypass filters" to "Los servicios legítimos utilizan dominios; Las IP ocultan la identidad y evitan los filtros",
    "Let's Encrypt (R3)" to "Let's Encrypt (R3)",
    "Light" to "Light",
    "Limited Browser Support" to "Soporte limitado del navegador",
    "Link copied to clipboard!" to "¡Enlace copiado al portapapeles!",
    "LinkedIn" to "LinkedIn",
    "LinkedIn uses linkedin.com as their primary domain. Profile URLs follow the /in/username format." to "LinkedIn utiliza linkedin.com como su dominio principal. Las URL del perfil siguen el formato /in/nombre de usuario.",
    "Live Hint" to "Pista en vivo",
    "Live Preview" to "Vista previa en vivo",
    "Live Scanner" to "Escáner en vivo",
    "Live Scoreboard" to "Marcador en vivo",
    "Local DB" to "Base de datos local",
    "Local Database" to "Base de datos local",
    "Local Memory (RAM)" to "Memoria local (RAM)",
    "Local Privacy" to "Local Privacidad",
    "Local Sandbox" to "Sandbox local",
    "Local database v2.4.1 active. No data leaves this device." to "Base de datos local v2.4.1 activa. No salen datos de este dispositivo.",
    "Local storage (history won\\'t persist)" to "Almacenamiento local (el historial no persistirá)",
    "Long URLs can hide malicious parameters or overwhelm users" to "Las URL largas pueden ocultar parámetros maliciosos o abrumar a los usuarios",
    "Look at the domain carefully. Is \"c0mmonwealth\" spelled correctly? The number 0 is often used to replace the letter O." to "Mire el dominio con atención. ¿Se escribe correctamente \"c0mmonwealth\"? El número 0 se utiliza a menudo para reemplazar la letra O.",
    "Look at the domain name carefully. Is \"paypa1\" spelled correctly?" to "Mire el nombre de dominio con atención. ¿Está \"paypa1\" escrito correctamente?",
    "Look closely at the domain structure. Legitimate organisations rarely use hyphens in the main domain name or generic TLDs like" to "Mire de cerca la estructura del dominio. Las organizaciones legítimas rara vez usan guiones en el nombre de dominio principal o TLD genéricos como",
    "Low" to "Bajo",
    "Low Risk" to "Bajo riesgo",
    "Low Sensitivity Mode" to "Modo de baja sensibilidad",
    "MALICIOUS" to "MALICIOSO",
    "MEDIUM" to "MEDIO",
    "MEDIUM RISK" to "MEDIO RIESGO",
    "MINOR CONCERNS" to "MENOR PREOCUPACIONES",
    "Machine-Readable" to "Lectura automática",
    "Make your decision" to "Tome su decisión",
    "Malicious" to "Malicioso",
    "Manage privacy controls, sensitivity, and security lists." to "Administre controles de privacidad, sensibilidad y listas de seguridad.",
    "Matched 3 signatures in local phishing DB." to "Coincidencia de 3 firmas en la base de datos de phishing local.",
    "Maximum protection. Blocks any suspicious patterns including newly registered domains, uncommon TLDs, and any URL with potential encoding tricks." to "Máxima protección. Bloquea cualquier patrón sospechoso, incluidos dominios recién registrados, TLD poco comunes y cualquier URL con posibles trucos de codificación.",
    "Medium" to "Medio",
    "Microsoft-owned platform" to "Plataforma propiedad de Microsoft",
    "Missing features:" to "Funciones faltantes:",
    "More than 3 subdomain levels (secure.login.paypal.fake.com)" to "Más de 3 niveles de subdominio (secure.login.paypal.fake.com)",
    "Need help? Visit our GitHub for documentation" to "¿Necesita ayuda? Visite nuestro GitHub para obtener documentación",
    "Never trust shortened URLs from unknown sources. Use URL expander tools to see the real destination before clicking." to "Nunca confíe en URL acortadas de fuentes desconocidas. Utilice herramientas de expansión de URL para ver el destino real antes de hacer clic.",
    "Newly Registered Domain" to "Dominio recién registrado",
    "Next Round" to "Siguiente ronda",
    "Next →" to "Siguiente →",
    "No Cloud Logs" to "Sin registros de nube",
    "No HTTPS Encryption" to "Sin cifrado HTTPS",
    "No HTTPS encryption" to "Sin cifrado HTTPS",
    "No QR code found in image" to "No se encontró ningún código QR en imagen",
    "No URL to copy" to "No hay URL para copiar",
    "No URL to open" to "No hay URL para abrir",
    "No URL to report - analyze one first" to "No hay URL para informar: analice una primero",
    "No camera found" to "No se encontró ninguna cámara",
    "No custom domains blocked." to "No se bloquearon dominios personalizados.",
    "No data leaves device" to "No hay datos que salgan del dispositivo",
    "No new notifications" to "No hay notificaciones nuevas",
    "No recent analysis to view" to "No hay análisis recientes para ver",
    "No recent scans" to "No hay análisis recientes",
    "No security threats were detected. The QR code leads to a verified safe destination." to "No se detectaron amenazas de seguridad. El código QR conduce a un destino seguro verificado.",
    "No threats detected" to "No se detectaron amenazas",
    "None" to "Ninguno",
    "Not a valid URL" to "No es una URL válida",
    "Not found in 52 local offline threat databases." to "No se encuentra en 52 bases de datos de amenazas locales fuera de línea.",
    "Not the official PayPal domain (paypal.com)" to "No es el dominio oficial de PayPal (paypal.com)",
    "Notifications" to "Notificaciones",
    "Obfuscated JavaScript" to "Ocultado JavaScript",
    "Obfuscated Script" to "Script ofuscado",
    "Official LinkedIn domain" to "Dominio oficial de LinkedIn",
    "Official postal services use their primary domain (auspost.com.au) for all tracking. Verify by visiting the official website directly." to "Los servicios postales oficiales utilizan su dominio principal (auspost.com.au) para todo el seguimiento. Verifique visitando el sitio web oficial directamente.",
    "Offline" to "Sin conexión",
    "Offline Core v2.4" to "Sin conexión Core v2.4",
    "Offline Engine V.2.4" to "Motor sin conexión V.2.4",
    "Offline Guarantee:" to "Garantía sin conexión:",
    "Offline Mode" to "Modo sin conexión",
    "Offline Mode Active" to "Modo sin conexión activo",
    "Offline Privacy" to "Privacidad sin conexión",
    "Offline Protection" to "Protección sin conexión",
    "Offline Ready" to "Listo sin conexión",
    "Offline Security" to "Seguridad sin conexión",
    "Offline-First Architecture" to "Arquitectura sin conexión",
    "On-Device DB" to "DB en el dispositivo",
    "On-Device Database" to "Base de datos en el dispositivo",
    "Onboarding" to "Incorporación",
    "Only blocks known malicious URLs from the threat database. Minimal false positives, but may miss novel attacks." to "Solo bloquea las URL maliciosas conocidas de la base de datos de amenazas. Falsos positivos mínimos, pero pueden pasar por alto ataques novedosos.",
    "Open Safely (Sandbox)" to "Abrir de forma segura (Sandbox)",
    "Open Source Licenses" to "Licencias de código abierto",
    "Opening PhishTank..." to "Abriendo PhishTank...",
    "Opening URL in new tab" to "Abrir URL en una nueva pestaña",
    "Opening email client..." to "Abrir cliente de correo electrónico...",
    "Optimised for desktop environments. Scans are processed in under 5ms using native Kotlin Multiplatform binaries." to "Optimizado para entornos de escritorio. Los escaneos se procesan en menos de 5 ms utilizando binarios multiplataforma nativos de Kotlin.",
    "Overview" to "Descripción general",
    "PASS" to "PASS",
    "PDF format. Best for sharing with stakeholders." to "Formato PDF. Lo mejor para compartir con las partes interesadas.",
    "PDF report ready for download" to "Informe PDF listo para descargar",
    "PHISH" to "PHISH",
    "PHISHING" to "PHISHING",
    "PROCEED WITH CAUTION" to "PROCEDER CON PRECAUCIÓN",
    "Paranoia" to "Paranoia",
    "Paranoia Mode" to "Modo Paranoia",
    "Paste URL" to "Pegar URL",
    "Paste URL to Analyze" to "Pegar URL en Analizar",
    "PayPal Security" to "Seguridad de PayPal",
    "Permissive" to "Permisivo",
    "Phishing" to "Phishing",
    "Phishing Attempt" to "Intento de phishing",
    "Phishing Detection Sensitivity" to "Sensibilidad de detección de phishing",
    "Phishing Engine" to "Motor de phishing",
    "Phishing Report: {url}" to "Informe de phishing: {url}",
    "Phishing detection is running normally" to "La detección de phishing se está ejecutando normalmente",
    "Play Again" to "Reproducir de nuevo",
    "Play Now" to "Reproducir ahora",
    "Play sound when threat detected" to "Reproducir sonido cuando se detecte una amenaza",
    "Please drop an image file" to "Por favor, suelte un archivo de imagen",
    "Please enter a URL" to "Por favor ingrese una URL",
    "Please enter a domain" to "Por favor ingrese un dominio",
    "Please enter a valid domain" to "Por favor ingrese un dominio válido",
    "Please select an image" to "Por favor seleccione una imagen",
    "Point your camera at a QR code to detect" to "Apunte su cámara a un Código QR para detectar",
    "Points" to "Puntos",
    "Press Cmd/Ctrl+V again to paste" to "Presione Cmd/Ctrl+V nuevamente para pegar",
    "Privacy Controls" to "Controles de privacidad",
    "Privacy Policy" to "Política de privacidad",
    "Privacy Settings" to "Configuración de privacidad",
    "Privacy policy: 100% offline, zero data collection" to "Política de privacidad: 100% fuera de línea, cero recopilación de datos",
    "Proceed with Caution" to "Continuar con Precaución",
    "Processing Env" to "Procesando Env",
    "Processing image..." to "Procesando imagen...",
    "Profile" to "Perfil",
    "Profile updated successfully!" to "¡Perfil actualizado correctamente!",
    "Punycode Domain" to "Dominio Punnycode",
    "QR Code Detected!" to "¡Código QR detectado!",
    "QR Code Scan" to "Escaneo de código QR",
    "QR Code detected!" to "Código QR detectado!",
    "Mehr Guard" to "Mehr Guard",
    "Mehr Guard - Beat the Bot" to "Mehr Guard - Beat the Bot",
    "Mehr Guard - Dashboard" to "Mehr Guard - Panel de control",
    "Mehr Guard - Offline Privacy Onboarding" to "Mehr Guard - Incorporación de privacidad sin conexión",
    "Mehr Guard - Scan Dashboard" to "Mehr Guard - Panel de escaneo",
    "Mehr Guard - Scan Result" to "Mehr Guard - Scan Resultado",
    "Mehr Guard - Trust Centre" to "Mehr Guard - Centro de confianza",
    "Mehr Guard Logo" to "Mehr Guard Logotipo",
    "Mehr Guard Results" to "Mehr Guard Resultados",
    "Mehr Guard Scan Result" to "Mehr Guard Resultado del análisis",
    "Mehr Guard Security Audit" to "Mehr Guard Auditoría de seguridad",
    "Mehr Guard Threat Analysis Report" to "Mehr Guard Análisis de amenazas Informe",
    "Mehr Guard Threat Report" to "Mehr Guard Informe de amenazas",
    "Mehr Guard Verdict: {verdict}" to "Mehr Guard Veredicto: {verdict}",
    "Mehr Guard analyses potential threats directly on your hardware. Experience" to "Mehr Guard analiza amenazas potenciales directamente en su hardware. La experiencia",
    "Mehr Guard explains" to "Mehr Guard explica",
    "Mehr Guard needs camera access to scan QR codes in real-time." to "Mehr Guard necesita acceso a la cámara para escanear códigos QR en tiempo real.",
    "Mehr Guard processes every scan within a secure, isolated local sandbox. We prioritize explainable security with zero cloud telemetry for image analysis." to "Mehr Guard procesa cada escaneo dentro de una zona de pruebas local segura y aislada. Priorizamos la seguridad explicable con cero telemetría en la nube para el análisis de imágenes.",
    "Mehr Guard strictly disables all outgoing telemetry. Your scan results, URL history, and image hashes never leave your device." to "Mehr Guard desactiva estrictamente toda la telemetría saliente. Los resultados del escaneo, el historial de URL y los hashes de imágenes nunca salen de su dispositivo.",
    "Mehr Guard uses local heuristic analysis engines. No image data, URL strings, or metadata leaves this device during scanning. Your privacy is mathematically guaranteed." to "Mehr Guard utiliza motores de análisis heurísticos locales. No salen datos de imágenes, cadenas de URL ni metadatos de este dispositivo durante el escaneo. Tu privacidad está matemáticamente garantizada.",
    "Mehr Guard works 100% offline! All analysis is done locally on your device. No internet connection required." to "Mehr Guard funciona 100% sin conexión. Todo el análisis se realiza localmente en su dispositivo. No se requiere conexión a Internet.",
    "Mehr Guard | Premium Web Scanner" to "[[MARCA]] | Escáner web premium",
    "Mehr Guard Bot" to "Mehr Guard Bot",
    "Quarantine in Sandbox" to "Cuarentena en Sandbox",
    "Quarantined in secure sandbox for analysis" to "En cuarentena en Sandbox seguro para análisis",
    "READY" to "LISTO",
    "Randomly generated domains are often temporary phishing sites" to "Los dominios generados aleatoriamente suelen ser sitios de phishing temporales",
    "Raw Image Buffer" to "Búfer de imágenes sin formato",
    "Read Only" to "Leer Solo",
    "Real-Time Scanning" to "Escaneo en tiempo real",
    "Real-time scanning" to "Escaneo en tiempo real",
    "Recent Scans" to "Escaneos recientes",
    "Recommended Actions" to "Acciones recomendadas",
    "Refresh Page" to "Actualizar página",
    "Removed {domain} from {list}" to "Se eliminó {domain} de {list}",
    "Removing or changing the suspicious pattern would reduce the overall risk score." to "Eliminar o cambiar el patrón sospechoso reduciría el riesgo general puntuación.",
    "Report Export - Mehr Guard" to "Exportación de informe - [[MARCA]]",
    "Report Generation" to "Generación de informe",
    "Report Incorrect Verdict" to "Informe de veredicto incorrecto",
    "Report Phishing" to "Informe de phishing",
    "Report URL copied to clipboard" to "Informe URL copiada al portapapeles",
    "Report copied to clipboard" to "Informe copiado al portapapeles",
    "Report if this verdict is wrong" to "Informe si este veredicto es incorrecto",
    "Report shared" to "Informe compartido",
    "Report shared successfully!" to "¡Informe compartido correctamente!",
    "Reported: {timestamp}" to "Reportado: {timestamp}",
    "Reports" to "Informes",
    "Reset Defaults" to "Restablecer valores predeterminados",
    "Reset all Trust Centre settings to default?" to "¿Restablecer todas las configuraciones del Centro de confianza a sus valores predeterminados?",
    "Reset all settings to default" to "Restablecer todas las configuraciones a predeterminado",
    "Response" to "Respuesta",
    "Result" to "Resultado",
    "Result # {id}" to "Resultado # {id}",
    "Result #8291-A" to "Resultado #8291-A",
    "Result copied to clipboard!" to "¡Resultado copiado al portapapeles!",
    "Results Dashboard" to "Panel de resultados",
    "Return to Dashboard" to "Volver al panel",
    "Risk Assessment" to "Riesgo Evaluación",
    "Risk Score" to "Puntuación de riesgo",
    "Risk Score: {score}/100" to "Puntuación de riesgo: {score}/100",
    "Risk impact:" to "Impacto del riesgo:",
    "Round" to "Ronda",
    "SAFE" to "SEGURO",
    "SAFE TO VISIT" to "SEGURO PARA VISITAR",
    "SMS from unknown number impersonating AusPost" to "SMS de un número desconocido que se hace pasar por AusPost",
    "SSL Certificate Issues" to "Problemas de certificado SSL",
    "SUSPICIOUS" to "SOSPECHOSO",
    "SUSPICIOUS ACTIVITY" to "ACTIVIDAD SOSPECHOSA",
    "Safe" to "Seguro",
    "Safe Scans" to "Escaneos seguros",
    "Safe to Visit" to "Seguro para Visitar",
    "Safe vs Risky QR Codes" to "Códigos QR seguros versus riesgosos",
    "Safety Score" to "Puntuación de seguridad",
    "Save & Continue" to "Guardar y continuar",
    "Scan" to "Escanear",
    "Scan # {id}" to "Escanear # {id}",
    "Scan #8021-AF" to "Escanear #8021-AF",
    "Scan Another" to "Escanear otro",
    "Scan Complete" to "Escanear Completo",
    "Scan History" to "Historial de escaneo",
    "Scan Meta" to "Escanear meta",
    "Scan Monitor" to "Escanear monitor",
    "Scan New QR" to "Escanear nuevo QR",
    "Scan QR" to "Escanear QR",
    "Scan QR Code" to "Escanear código QR",
    "Scan QR codes as they're detected" to "Escanear códigos QR a medida que se detectan",
    "Scan Time" to "Tiempo de escaneo",
    "Scan URLs Safely" to "Escanear URL de forma segura",
    "Scan history cleared" to "Historial de escaneo borrado",
    "Scan this QR code with Mehr Guard to see malicious URL detection:" to "Escanee este código QR con Mehr Guard para ver la detección de URL maliciosas:",
    "Scanned with Mehr Guard - {url}" to "Escaneado con Mehr Guard - {url}",
    "Scanner Dashboard" to "Escáner Panel de control",
    "Scanning..." to "Escaneo...",
    "Scans" to "Escaneos",
    "Scans for known malicious patterns and heuristic mismatches. Blocks homoglyph attacks and redirect chains. Low false positive rate expected." to "Escaneos en busca de patrones maliciosos conocidos y discrepancias heurísticas. Bloquea ataques de homoglifos y cadenas de redireccionamiento. Se espera una tasa baja de falsos positivos.",
    "Secure Environment" to "Entorno seguro",
    "Secure. Offline." to "Seguro. Sin conexión.",
    "Security" to "Seguridad",
    "Security Analyst" to "Analista de seguridad",
    "Security Audit: PASS" to "Auditoría de seguridad: PASS",
    "Security Engine Active" to "Motor de seguridad activo",
    "Security Heuristics" to "Heurística de seguridad",
    "Security Settings" to "Configuración de seguridad",
    "Security audit report downloaded" to "Informe de auditoría de seguridad descargado",
    "See Results" to "Ver Resultados",
    "See the difference instantly:" to "Vea la diferencia al instante:",
    "Sensitivity Level" to "Nivel de sensibilidad",
    "Sensitivity set to {level}" to "Sensibilidad establecida en {level}",
    "Session ID: #GAME-" to "ID de sesión: #JUEGO-",
    "Settings" to "Configuración",
    "Settings are saved automatically and sync across sessions." to "La configuración se guarda automáticamente y se sincroniza entre sesiones.",
    "Settings reset to default" to "La configuración se restablece a predeterminado",
    "Settings reset to defaults" to "Configuración restablecida a los valores predeterminados",
    "Settings saved! Your data stays on-device." to "¡Configuración guardada! Tus datos permanecen en el dispositivo.",
    "Share" to "Compartir",
    "Share Report" to "Compartir informe",
    "Share detection stats to improve ML." to "Compartir estadísticas de detección para mejorar el aprendizaje automático.",
    "Shared successfully!" to "¡Compartido correctamente!",
    "Sharing not supported" to "Compartir no admitido",
    "Short URLs hide the actual destination. Prize claims from unknown numbers are almost always scams." to "Las URL cortas ocultan el destino real. Los reclamos de premios de números desconocidos casi siempre son estafas.",
    "Shortened URL hides true destination" to "La URL acortada oculta el destino verdadero",
    "Show Confidence Score" to "Mostrar puntaje de confianza",
    "Show visual alerts for threats" to "Mostrar alertas visuales para amenazas",
    "Sign in to your GitHub account to access your repositories." to "Inicia sesión en tu cuenta de GitHub para acceder a tu repositorios.",
    "Signatures" to "Firmas",
    "Skip" to "Omitir",
    "Some features may not work in your browser." to "Algunas funciones pueden no funcionar en su navegador.",
    "Some minor security concerns were identified. The link appears mostly safe but review recommended." to "Se identificaron algunos problemas de seguridad menores. El enlace parece mayoritariamente seguro, pero se recomienda revisarlo.",
    "Some suspicious indicators detected. Verify the source before entering sensitive information." to "Se detectaron algunos indicadores sospechosos. Verifique la fuente antes de ingresar información confidencial.",
    "Sound Alerts" to "Alertas de sonido",
    "Sound alerts" to "Alertas de sonido",
    "Source" to "Fuente",
    "Standard Gmail URL structure" to "Estructura de URL estándar de Gmail",
    "Standard Google Docs URL format" to "Formato de URL estándar de Google Docs",
    "Standard profile URL structure" to "URL de perfil estándar estructura",
    "Status" to "Estado",
    "Streak:" to "Racha:",
    "Strict" to "Estricto",
    "Strict Offline Guarantee" to "Garantía estricta sin conexión",
    "Strict Offline Mode" to "Modo estricto sin conexión",
    "Strict Offline Mode disabled" to "Modo estricto sin conexión desactivado",
    "Strict Offline Mode enabled" to "Modo estricto sin conexión habilitado",
    "Subdomain \"signin\" used for deception" to "Subdominio \"inicio de sesión\" utilizado para engaño",
    "Subdomain of google.com" to "Subdominio de google.com",
    "Subdomain of google.com (trusted)" to "Subdominio de google.com (confiable)",
    "Submitted via Mehr Guard" to "Enviado a través de [[MARCA]]",
    "Success!" to "¡Éxito!",
    "Support" to "Soporte",
    "Suspicious" to "Sospechoso",
    "Suspicious Redirect Chain" to "Redireccionamiento sospechoso Cadena",
    "Suspicious TLD" to "TLD sospechoso",
    "Suspicious TLD (.tk)" to "TLD sospechoso (.tk)",
    "Switch Language: English/Deutsch" to "Cambiar idioma: inglés/alemán",
    "Switched to {mode} mode" to "Cambiado al modo {mode}",
    "System Health" to "Salud del sistema",
    "System Secure" to "Sistema seguro",
    "System Status" to "Sistema Estado",
    "Systems Operational" to "Sistemas operativos",
    "TLD" to "TLD",
    "Target IP is located in a high-risk ASN." to "La IP de destino está ubicada en un ASN de alto riesgo.",
    "Target URL" to "URL de destino",
    "Technical Indicators" to "Indicadores técnicos",
    "Technical Indicators:" to "Indicadores técnicos:",
    "Terms" to "Términos",
    "Test QR Code" to "Probar QR Código",
    "Thank you! Feedback recorded: Should be {verdict}" to "¡Gracias! Comentarios registrados: Debería ser {verdict}",
    "The Kotlin/JS analysis engine is still loading or failed to initialize." to "El motor de análisis Kotlin/JS aún se está cargando o no se pudo inicializar.",
    "The bot was faster this time. Try again!" to "El bot fue más rápido esta vez. ¡Inténtalo de nuevo!",
    "The destination URL employs" to "La URL de destino emplea",
    "The domain uses the Cyrillic 'а' (U+0430) instead of Latin 'a' (U+0061)." to "El dominio usa el cirílico 'а' (U+0430) en lugar de la 'a' latina (U+0061).",
    "The domain uses the Cyrillic 'а' (U+0430) instead of Latin 'a' (U+0061). This technique is commonly used to trick users into believing they are visiting a legitimate service." to "El dominio usa el cirílico 'а' (U+0430) en lugar de la 'a' latina (U+0061). Esta técnica se usa comúnmente para engañar a los usuarios haciéndoles creer que están visitando un servicio legítimo.",
    "The entire threat signature database (100,000+ patterns) is stored locally for millisecond lookups without any network requests." to "Toda la base de datos de firmas de amenazas (más de 100,000 patrones) se almacena localmente para búsquedas de milisegundos sin ninguna solicitud de red.",
    "The entire threat signature database is downloaded to your device for millisecond lookups." to "Toda la base de datos de firmas de amenazas se descarga a su dispositivo para búsquedas de milisegundos.",
    "The image doesn\\'t contain a recognizable QR code, or it may be damaged." to "La imagen no contiene un código QR reconocible, o puede que sí lo esté dañado.",
    "The input doesn\\'t appear to be a valid URL." to "La entrada no parece ser una URL válida.",
    "The number 1 and lowercase L look identical in many fonts. Always verify paypal.com directly." to "El número 1 y la L minúscula parecen idénticos en muchas fuentes. Siempre verifique paypal.com directamente.",
    "The pattern matches known phishing characteristics" to "El patrón coincide con características de phishing conocidas",
    "The scanned QR code contains malicious indicators associated with phishing and credential harvesting. Do not proceed to the target URL." to "El código QR escaneado contiene indicadores maliciosos asociados con phishing y recolección de credenciales. No continúe con la URL de destino.",
    "The scanned QR code shows suspicious patterns that may indicate potential security risks. Proceed with caution." to "El código QR escaneado muestra patrones sospechosos que pueden indicar posibles riesgos de seguridad. Proceda con precaución.",
    "Think you can outsmart our AI? Try to craft a phishing URL that fools the detector!" to "¿Crees que puedes ser más astuto que nuestra IA? ¡Intenta crear una URL de phishing que engañe al detector!",
    "This URL passed all {count} security checks" to "Esta URL pasó todos los controles de seguridad {count}",
    "This URL triggered a security check" to "Esta URL activó un control de seguridad.",
    "This URL was flagged by Mehr Guard\\'s offline phishing detection engine." to "Esta URL fue marcada por el motor de detección de phishing fuera de línea de Mehr Guard\\.",
    "This image was analysed locally on your device. No data was sent to the cloud for this verdict." to "Esta imagen fue analizada localmente en su dispositivo. No se enviaron datos a la nube para este veredicto.",
    "This is a Google subdomain - check if it\\'s the legitimate Gmail service." to "Este es un subdominio de Google; verifique si es el servicio legítimo de Gmail.",
    "This is a security feature — your URLs never leave your device." to "Esta es una característica de seguridad: sus URL nunca salen de su dispositivo.",
    "This is a well-established software company domain." to "Este es un dominio de empresa de software bien establecido.",
    "This is the official LinkedIn domain for professional networking." to "Este es el dominio oficial de LinkedIn para networking profesional.",
    "This may happen if: • You're using a very old browser • JavaScript is disabled • The page didn't fully load Try refreshing the page. If the issue persists, try Chrome, Firefox, or Safari." to "Esto puede suceder si: • Está utilizando un navegador muy antiguo • JavaScript está deshabilitado • La página no se cargó por completo Intente actualizar la página. Si el problema persiste, prueba Chrome, Firefox o Safari.",
    "This was actually {label}." to "En realidad, esto era {label}.",
    "This was {label}." to "Este era {label}.",
    "Threat Alerts" to "Alertas de amenazas",
    "Threat Analysis" to "Análisis de amenazas",
    "Threat Analysis Report" to "Informe de análisis de amenazas",
    "Threat Confidence" to "Confianza en la amenaza",
    "Threat Database" to "Base de datos de amenazas",
    "Threat Detected" to "Amenaza detectada",
    "Threat Verdict" to "Veredicto de amenaza",
    "Threat alerts" to "Alertas de amenazas",
    "Threat blocked and reported" to "Amenaza bloqueada y reportada",
    "Threat database is up to date" to "La base de datos de amenazas está actualizada",
    "Threat signatures updated to v2.4.1" to "Firmas de amenazas actualizadas a v2.4.1",
    "Threats" to "Amenazas",
    "Time" to "Tiempo",
    "Tips for better scanning: • Ensure good lighting • Hold the camera steady • Fill the frame with the QR code • Avoid glare or reflections • Try uploading a clearer image" to "Consejos para escanear mejor: • Asegure una buena iluminación • Mantenga la cámara firme • Llene el marco con el código QR • Evite brillos o reflejos • Intente cargar una imagen más clara",
    "Today, 04:00 AM" to "Hoy, 04:00 a.m.",
    "Today, 14:32:05" to "Hoy, 14:32:05",
    "Today, {time}" to "Hoy, {time}",
    "Toggle Judge Mode" to "Alternar modo de juez",
    "Toggle Language" to "Alternar idioma",
    "Toggle Theme" to "Alternar tema",
    "Toggle light/dark mode" to "Alternar modo claro/oscuro",
    "Toggle menu" to "Alternar menú",
    "Toggle theme" to "Alternar tema",
    "Top 100 Alexa Rank - whitelisted" to "Clasificación Top 100 de Alexa: incluida en la lista blanca",
    "Top 1k Alexa Rank whitelisted offline." to "Top 1k Rank de Alexa incluido en la lista blanca sin conexión.",
    "Top Analysis Factors" to "Principales factores de análisis",
    "Torch" to "Antorcha",
    "Torch error" to "Error de antorcha",
    "Torch not available" to "Antorcha no disponible",
    "Torch off" to "Antorcha apagada",
    "Torch on" to "Antorcha encendida",
    "Training" to "Capacitación",
    "Training Centre" to "Centro de formación",
    "Trust Centre" to "Centro de confianza",
    "Try Again" to "Intentar otra vez",
    "Try It Now!" to "¡Pruébalo ahora!",
    "Typosquatting" to "Error tipográfico",
    "Typosquatting Detected" to "Error tipográfico detectado",
    "Typosquatting pattern detected" to "Patrón de sentadilla tipográfica detectado",
    "UNKNOWN" to "DESCONOCIDO",
    "URL" to "URL",
    "URL Shortener" to "Acortador de URL",
    "URL Shortener Detected" to "Acortador de URL detectado",
    "URL contains Cyrillic, Greek, or other lookalike Unicode characters" to "La URL contiene caracteres Unicode cirílicos, griegos u otros caracteres similares.",
    "URL contains another URL in query parameters" to "La URL contiene otra URL en los parámetros de consulta.",
    "URL copied to clipboard!" to "¡URL copiada al portapapeles!",
    "URL exceeds 100 characters" to "La URL supera los 100 caracteres.",
    "URL parsing (please update your browser)" to "Análisis de URL (actualice su navegador)",
    "URL pasted - press Enter to analyze" to "URL pegada: presione Entrar para analizar",
    "URL path contains /login, /signin, /verify, /secure, /account" to "La ruta URL contiene /login, /signin, /verify, /secure, /account",
    "URL to analyze" to "URL para analizar",
    "URL uses raw IP address instead of domain name" to "La URL utiliza una dirección IP sin formato en lugar de un nombre de dominio",
    "URL:" to "URL:",
    "URL: {url}" to "URL: {url}",
    "URL: {url}\\nVerdict: {verdict}\\nConfidence: {confidence}%" to "URL: {url}\\nVeredicto: {verdict}\\nConfianza: {confidence}%",
    "URLs are risky!" to "¡Las URL son riesgosas!",
    "Unable to determine verdict. Please try again." to "No se puede determinar el veredicto. Por favor inténtalo de nuevo.",
    "Unknown" to "Desconocido",
    "Unknown URL" to "URL desconocida",
    "Unknown Verdict" to "Veredicto desconocido",
    "Unknown sender number" to "Número de remitente desconocido",
    "Unsolicited prize notification" to "Notificación de premio no solicitado",
    "Upload" to "Subir",
    "Upload Image" to "Subir imagen",
    "Upload Image Instead" to "Subir imagen en su lugar",
    "Urgency tactics in message" to "Tácticas de urgencia en el mensaje.",
    "Use condensed layout for results" to "Utilice un diseño condensado para obtener resultados",
    "Users may not notice subtle character swaps like \"1\" for \"l\" or \"0\" for \"o\"" to "Es posible que los usuarios no noten cambios sutiles de caracteres como \"1\" por \"l\" o \"0\" por \"o\".",
    "Uses bit.ly, t.co, tinyurl, or similar shortening service" to "Utiliza bit.ly, t.co, tinyurl o un servicio de acortamiento similar",
    "Uses high-risk TLDs like .tk, .ml, .ga, .cf, .xyz" to "Utiliza TLD de alto riesgo como .tk, .ml, .ga, .cf, .xyz",
    "VERIFIED SAFE" to "SEGURO VERIFICADO",
    "VS" to "contra",
    "VS MODE" to "MODO CONTRA",
    "Valid Extended Validation certificate" to "Certificado de Validación Extendida válido",
    "Valid Google certificate" to "Certificado de Google válido",
    "Valid SSL Certificate" to "Certificado SSL válido",
    "Verdict" to "Veredicto",
    "Verdict: {verdict}" to "Veredicto: {verdict}",
    "VerdictPhish" to "Veredicto Phish",
    "VerdictSafe" to "VeredictoSeguro",
    "VerdictWarn" to "VeredictoAdvertir",
    "Verified by Mehr Guard Enterprise" to "Verificado por [[MARCA]] Empresa",
    "Verified by Mehr Guard Enterprise v{version}" to "Verificado por Mehr Guard Enterprise v{version}",
    "Verified by local heuristics v2.4. No phishing patterns, obfuscated scripts, or blacklist matches found." to "Verificado por heurística local v2.4. No se encontraron patrones de phishing, scripts ofuscados ni coincidencias de listas negras.",
    "Verifying..." to "Verificando...",
    "Version" to "Versión",
    "Very High" to "muy alto",
    "View All" to "Ver todo",
    "View Full History" to "Ver historial completo",
    "View Full Report" to "Ver informe completo",
    "View John Smith\\'s professional profile on LinkedIn." to "Ver el perfil profesional de John Smith en LinkedIn.",
    "View Security Audit" to "Ver auditoría de seguridad",
    "View detailed analysis in dashboard" to "Ver análisis detallado en el panel de control",
    "Visual Appearance (What user sees)" to "Apariencia visual (lo que ve el usuario)",
    "WARN" to "ADVERTENCIA",
    "Warning" to "Advertencia",
    "We detect multiple attack types:" to "Detectamos múltiples tipos de ataques:",
    "We strictly disable outgoing telemetry for scans. Scan results and image hashes remain local." to "Desactivamos estrictamente la telemetría saliente para los análisis. Los resultados del escaneo y los hashes de imágenes permanecen locales.",
    "Welcome to Jira - project tracking for agile teams." to "Bienvenido a Jira: seguimiento de proyectos para equipos ágiles.",
    "Welcome to Mehr Guard" to "Bienvenido a Mehr Guard",
    "What it checks:" to "Qué verifica:",
    "Why it matters:" to "Por qué es importante:",
    "Why the bot flagged it" to "Por qué el bot lo marcó",
    "Why this verdict?" to "Por qué esto veredicto?",
    "Without other risk signals, login paths on safe domains would not increase score significantly." to "Sin otras señales de riesgo, las rutas de inicio de sesión en dominios seguros no aumentarían significativamente la puntuación.",
    "Works 100% offline!" to "¡Funciona 100% sin conexión!",
    "Workspace / Security / Reports" to "Espacio de trabajo / Seguridad / Informes",
    "Would you like to report this URL?\\n\\nOptions:\\n1. PhishTank - Click OK to open submission page\\n2. Email - Click Cancel to compose email\\n\\nURL: {url}" to "¿Le gustaría informar esta URL?\\n\\nOpciones:\\n1. PhishTank: haga clic en Aceptar para abrir la página de envío\\n2. Correo electrónico: haz clic en Cancelar para redactar el correo electrónico\\n\\nURL: {url}",
    "Wrong Verdict?" to "¿Veredicto incorrecto?",
    "Wrong!" to "¡Incorrecto!",
    "Yesterday" to "Ayer",
    "You" to "Tú",
    "You can still use Mehr Guard by uploading images or pasting URLs directly." to "Aún puedes usar Mehr Guard cargando imágenes o pegando URL directamente.",
    "You can still use Mehr Guard: • Upload QR code images • Paste URLs directly • Use the sample URLs provided" to "Todavía puedes usar Mehr Guard Mehr Guard: • Cargar imágenes de códigos QR • Pegar URL directamente • Usar las URL de muestra proporcionadas",
    "You correctly identified this as {label}." to "Identificaste correctamente esto como {label}.",
    "You have 3 unread emails in your inbox." to "Tienes 3 correos electrónicos no leídos en tu bandeja de entrada.",
    "You identified the safe URL correctly." to "Identificaste correctamente la URL segura.",
    "You spotted it correctly as {label}!" to "¡Lo identificaste correctamente como {label}!",
    "You spotted the phishing URL correctly." to "¡Viste el URL de phishing correctamente.",
    "You're offline — analysis still works!" to "Estás desconectado: ¡el análisis aún funciona!",
    "You're reporting that this verdict may be wrong:" to "Estás informando que este veredicto puede ser incorrecto:",
    "You\\'re Offline" to "Estás desconectado",
    "Your Score" to "Tu puntuación",
    "Your browser doesn\\'t support camera access, or you\\'re on a device without a camera." to "Tu navegador no admite el acceso a la cámara o estás en un dispositivo sin cámara.",
    "Your data never leaves this device. All processing is local. No tracking, no uploads." to "Tus datos nunca salen este dispositivo. Todo el procesamiento es local. Sin seguimiento, sin cargas.",
    "Your data stays on-device." to "Tus datos permanecen en el dispositivo.",
    "\\nRisk Score:" to "\\nPuntuación de riesgo:",
    "a phishing attempt" to "un intento de phishing",
    "actually legitimate" to "realmente legítimo",
    "bit.ly shortener" to "bit.ly acortador",
    "characters often associated with phishing campaigns targeting financial institutions. The domain age is" to "caracteres a menudo asociados con campañas de phishing dirigidas a instituciones financieras. La antigüedad del dominio es",
    "critical" to "crítica",
    "danger" to "peligro",
    "for core services." to "para los servicios principales.",
    "high" to "alta",
    "homoglyph obfuscation" to "ofuscación de homoglifos",
    "in your browser." to "en su navegador.",
    "just now" to "solo ahora",
    "low" to "bajo",
    "malicious" to "malicioso",
    "medium" to "medio",
    "offline" to "sin conexión",
    "online" to "en línea",
    "or click \"Upload\" to select a file" to "o haga clic en \"Cargar\" para seleccionar un archivo",
    "phishing" to "phishing",
    "risk-badge danger" to "risk-badge peligro",
    "risk-badge warning" to "risk-badge advertencia",
    "risk-item-expanded severity-" to "elemento de riesgo-gravedad ampliada-",
    "safe" to "seguro",
    "suspicious" to "sospechoso",
    "to analyze," to "para analizar,",
    "to focus," to "para enfocar,",
    "to reset" to "para restablecer",
    "unknown" to "desconocido",
    "v2.4.1 •" to "v2.4.1 •",
    "warning" to "advertencia",
    "without compromising data privacy." to "sin comprometer la privacidad de los datos.",
    "zero-latency phishing detection" to "detección de phishing de latencia cero",
    "{date}, {time}" to "{date}, {time}",
    "{days} day ago" to "{days} hace días",
    "{days} days ago" to "{days} hace días",
    "{hours} hour ago" to "{hours} hora hace",
    "{hours} hours ago" to "{hours} hace horas",
    "{label} disabled" to "{label} deshabilitado",
    "{label} enabled" to "{label} habilitado",
    "{level} Confidence" to "{level} Confianza",
    "{minutes} minute ago" to "{minutes} hace minutos",
    "{minutes} minutes ago" to "{minutes} hace minutos",
    "{months} month ago" to "{months} mes hace",
    "{months} months ago" to "{months} hace meses",
    "{points} pts" to "{points} pts",
    "{title}: {summary}" to "{title}: {title}",
    "{weeks} week ago" to "{weeks} hace una semana",
    "{weeks} weeks ago" to "{weeks} hace semanas",
    "© 2025-2026 Mehr Guard Security Inc. All rights reserved." to "© 2025-2026 Mehr Guard Security Inc. Todos los derechos reservado.",
    "हिन्दी" to "हिन्दी",
    "⌨️ Tip: Press" to "⌨️ Consejo: Presione",
    "⚠ Try Phishing URL" to "⚠ Pruebe URL de phishing",
    "✅ No data leaves your device" to "✅ No salen datos de su dispositivo",
    "✅ Same engine as mobile apps" to "✅ Mismo motor que las aplicaciones móviles",
    "✅ Works without internet" to "✅ Funciona sin Internet",
    "✓ No brand impersonation" to " ✓ Sin marca suplantación",
    "✓ No homograph attacks" to " ✓ Sin ataques homógrafos ",
    "✓ No suspicious patterns" to " ✓ Sin patrones sospechosos",
    "✓ Safe TLD" to " ✓ TLD seguro",
    "✓ Try Safe URL" to " ✓ Pruebe URL segura",
    "日本語" to "日本語",
    "简体中文" to "简体中文",
    "🌐 Homograph attacks (Cyrillic chars)" to "🌐 Ataques homógrafos (cirílico chars)",
    "🎉 You Win!" to "🎉 ¡Tú ganas!",
    "🎬 Demo Mode: Click \"Analyze URL\" to see detection" to "🎬 Modo de demostración: haz clic en \"Analizar URL\" para ver la detección",
    "🎮 Craft a sneaky phishing URL..." to "🎮 Crea una URL de phishing furtiva...",
    "🎮 Game Mode: Try to craft a URL that gets detected as SAFE!" to "🎮 Modo de juego: ¡Intenta crear una URL que se detecte como SEGURA!",
    "🏆 Players challenged:" to "🏆 Jugadores desafiado:",
    "🏆 You beat the bot! Score: {score}/{attempts}" to "🏆 ¡Venceste al robot! Puntuación: {score}/{attempts}",
    "💡 What would reduce this?" to "💡 ¿Qué reduciría esto?",
    "🔒 100% offline • Zero data collection • Open source (Apache 2.0)" to "🔒 100 % fuera de línea • Recopilación de datos cero • Código abierto (Apache 2.0)",
    "🔒 Zero data collection • 🚀 Same engine as Android & iOS • 🧠 Ensemble ML (25+ heuristics)" to "🔒 Recopilación de datos cero • 🚀 Mismo motor que Android e iOS • 🧠 Ensemble ML (25+) heurísticas)",
    "🔗 URL shortener obfuscation" to "🔗 Ofuscación del acortador de URL",
    "🔤 Typosquatting (paypa1 → paypal)" to "🔤 Typosquatting (paypa1 → paypal)",
    "🛡️ Mehr Guard Analysis" to "🛡️ [[MARCA]] Análisis",
    "🛡️ Mehr Guard — Kotlin Multiplatform QRishing Detector" to "🛡️ [[MARCA]] — Kotlin Multiplataforma QRishing Detector",
    "🤖 Bot wins! Phishing detected. Score: {score}/{attempts}" to "🤖 Bot gana! Phishing detectado. Puntuación: {score}/{attempts}",
    "🧑‍⚖️ Demo: Forced MALICIOUS result" to "🧑‍⚖️ Demostración: resultado MALICIOSO forzado",
    "🧑‍⚖️ Judge Mode ON - All URLs will show MALICIOUS" to "🧑‍⚖️ Modo juez activado: todas las URL mostrarán MALICIOSO",
    "🧑‍⚖️ Judge Mode activated - Demo history loaded!" to "🧑‍⚖️ Modo juez activado - ¡Historial de demostración cargado!",
    "🧪 Try these examples:" to "🧪 Pruebe estos ejemplos:",
    "Added {date}" to "Añadido el {date}",
    "Analyzing..." to "Analizando...",
    "Camera N/A" to "Cámara no disponible",
    "Error analyzing URL: {error}" to "Error al analizar la URL: {error}",
    "Challenge Mehr Guard's offline AI engine. Can you spot phishing URLs faster than the bot?" to "Desafía al motor de IA sin conexión de Mehr Guard. ¿Puedes detectar URLs de phishing más rápido que el bot?",
    "Paste URL to analyze (e.g., https://example.com)" to "Pega la URL para analizar (p. ej., https://example.com)",
    "Mehr Guard Active Scanner - Real-time QR code scanning with AI-powered phishing detection." to "Escáner activo de Mehr Guard: escaneo de códigos QR en tiempo real con detección de phishing basada en IA.",
    "Mehr Guard Dashboard - Enterprise offline QR code security with explainable threat detection." to "Panel de Mehr Guard: seguridad de códigos QR offline para empresas con detección de amenazas explicable.",
    "Mehr Guard Privacy Settings - 100% offline protection with zero cloud telemetry." to "Ajustes de privacidad de Mehr Guard: protección 100% offline sin telemetría en la nube.",
    "Mehr Guard Report Export - Generate and download threat analysis reports in PDF or JSON format." to "Exportación de informes Mehr Guard: genera y descarga informes de análisis de amenazas en formato PDF o JSON.",
    "Mehr Guard Threat Analysis - Detailed scan result showing attack breakdown and security recommendations." to "Análisis de amenazas Mehr Guard: resultado detallado del escaneo con desglose de ataques y recomendaciones de seguridad.",
    "Mehr Guard Trust Centre - Manage privacy controls, detection sensitivity, and security lists." to "Centro de confianza de Mehr Guard: gestiona controles de privacidad, sensibilidad de detección y listas de seguridad.",
    "Mehr Guard Web - AI-powered phishing detection running entirely in your browser. Scan and analyze URLs for security threats." to "Mehr Guard Web: detección de phishing con IA que se ejecuta completamente en tu navegador. Escanea y analiza URLs en busca de amenazas de seguridad.",
    "Mehr Guard scan results - AI-powered phishing detection with detailed security analysis." to "Resultados de escaneo de Mehr Guard: detección de phishing con IA y análisis de seguridad detallado.",
    "why" to "por qué",
    "heuristics" to "heurísticas",
    "redirects" to "redirecciones",
    "ssl_issuer" to "ssl_emisor",
    "subdomain_chaining" to "encadenamiento_de_subdominios",
    "suspicious_tld" to "tld_sospechosa",
    "threat_type" to "tipo_de_amenaza",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "ACTIVIDAD SOSPECHOSA",
    WebStringKey.VerdictWarning to "Advertencia",
    WebStringKey.VerdictSuspiciousDesc to "El código QR escaneado muestra patrones sospechosos que pueden indicar riesgos de seguridad potenciales. Proceda con precaución.",
    WebStringKey.VerdictMinorConcerns to "PREOCUPACIONES MENORES",
    WebStringKey.VerdictCaution to "Precaución",
    WebStringKey.VerdictMinorConcernsDesc to "Se identificaron algunas preocupaciones de seguridad menores. El enlace parece mayormente seguro pero se recomienda revisar.",
    WebStringKey.VerdictVerifiedSafe to "VERIFICADO SEGURO",
    WebStringKey.VerdictSafeLabel to "Seguro",
    WebStringKey.VerdictVerifiedSafeDesc to "No se detectaron amenazas de seguridad. El código QR lleva a un destino seguro verificado.",
    WebStringKey.VerdictNoActivity to "Sin Actividad",
    WebStringKey.VerdictAwaitingScan to "Esperando Escaneo",
    WebStringKey.VerdictNoActivityDesc to "No hay datos de escaneo disponibles. Por favor escanee un código QR o ingrese una URL para analizar.",
    WebStringKey.ScanQrToSeeActivity to "Escanee un código QR para ver su actividad aquí",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "Punto de Datos",
    WebStringKey.ProcessingEnv to "Entorno de Procesamiento",
    WebStringKey.ExternalTransmission to "Transmisión Externa",
    WebStringKey.RawImageBuffer to "Buffer de Imagen Sin Procesar",
    WebStringKey.LocalMemoryRam to "Memoria Local (RAM)",
    WebStringKey.TransmissionNone to "Ninguna",
    WebStringKey.DecodedUrlPayload to "URL/Carga Decodificada",
    WebStringKey.LocalAnalysis to "Análisis Local",
    WebStringKey.ThreatVerdictLabel to "Veredicto de Amenaza",
    WebStringKey.LocalDatabase to "Base de Datos Local",
    
    // Reason Code Titles and Descriptions
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "URL de JavaScript",
    WebStringKey.ReasonJavascriptUrlDesc to "Esquema de URL JavaScript detectado - ejecuta código al hacer clic",
    WebStringKey.ReasonDataUriTitle to "URI de Datos",
    WebStringKey.ReasonDataUriDesc to "Esquema de URI de datos detectado - puede contener código malicioso incrustado",
    WebStringKey.ReasonAtSymbolInjectionTitle to "Inyección de Símbolo @",
    WebStringKey.ReasonAtSymbolInjectionDesc to "La URL contiene el símbolo @ indicando posible intento de robo de credenciales",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "Ataque Homógrafo",
    WebStringKey.ReasonHomographDesc to "El nombre de dominio internacionalizado (IDN) puede estar suplantando otro dominio",
    WebStringKey.ReasonMixedScriptTitle to "Script Mixto",
    WebStringKey.ReasonMixedScriptDesc to "El nombre de host contiene caracteres de diferentes scripts (posible suplantación)",
    WebStringKey.ReasonLookalikeCharsTitle to "Caracteres Similares",
    WebStringKey.ReasonLookalikeCharsDesc to "El dominio contiene caracteres Unicode que se parecen a letras ASCII",
    WebStringKey.ReasonZeroWidthCharsTitle to "Caracteres de Ancho Cero",
    WebStringKey.ReasonZeroWidthCharsDesc to "Caracteres Unicode ocultos de ancho cero detectados (intento de ofuscación)",
    WebStringKey.ReasonIpHostTitle to "Host IP",
    WebStringKey.ReasonIpHostDesc to "La URL usa dirección IP en lugar de nombre de dominio",
    WebStringKey.ReasonCredentialParamTitle to "Parámetro de Credenciales",
    WebStringKey.ReasonCredentialParamDesc to "La URL contiene parámetros relacionados con credenciales (contraseña, token, etc.)",
    WebStringKey.ReasonBrandImpersonationTitle to "Suplantación de Marca",
    WebStringKey.ReasonBrandImpersonationDesc to "La URL parece suplantar una marca conocida",
    WebStringKey.ReasonBrandInSubdomainTitle to "Marca en Subdominio",
    WebStringKey.ReasonBrandInSubdomainDesc to "El nombre de la marca aparece en el subdominio pero no en el dominio principal",
    WebStringKey.ReasonRiskyExtensionTitle to "Extensión Riesgosa",
    WebStringKey.ReasonRiskyExtensionDesc to "La ruta contiene extensión de archivo potencialmente peligrosa",
    WebStringKey.ReasonDoubleExtensionTitle to "Doble Extensión",
    WebStringKey.ReasonDoubleExtensionDesc to "Extensión de archivo doble detectada (táctica común de malware)",
    WebStringKey.ReasonEncodedPayloadTitle to "Carga Codificada",
    WebStringKey.ReasonEncodedPayloadDesc to "Datos codificados grandes detectados en parámetros de URL",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP en lugar de HTTPS",
    WebStringKey.ReasonHttpNotHttpsDesc to "La URL usa protocolo HTTP inseguro en lugar de HTTPS",
    WebStringKey.ReasonSuspiciousTldTitle to "TLD Sospechoso",
    WebStringKey.ReasonSuspiciousTldDesc to "Dominio de nivel superior frecuentemente usado para phishing",
    WebStringKey.ReasonHighEntropyHostTitle to "Host de Alta Entropía",
    WebStringKey.ReasonHighEntropyHostDesc to "El nombre de dominio parece generado aleatoriamente",
    WebStringKey.ReasonRedirectParamTitle to "Parámetro de Redirección",
    WebStringKey.ReasonRedirectParamDesc to "La URL contiene parámetro de redirección que puede llevar a otro sitio",
    WebStringKey.ReasonDeepSubdomainTitle to "Subdominio Profundo",
    WebStringKey.ReasonDeepSubdomainDesc to "Profundidad excesiva de subdominio (puede ocultar dominio real)",
    WebStringKey.ReasonMultiTldTitle to "Múltiples TLD",
    WebStringKey.ReasonMultiTldDesc to "Múltiples segmentos similares a TLD en el nombre de dominio",
    WebStringKey.ReasonNumericSubdomainTitle to "Subdominio Numérico",
    WebStringKey.ReasonNumericSubdomainDesc to "Subdominio solo numérico detectado",
    WebStringKey.ReasonNonStandardPortTitle to "Puerto No Estándar",
    WebStringKey.ReasonNonStandardPortDesc to "La URL usa número de puerto no estándar",
    WebStringKey.ReasonSuspiciousPortTitle to "Puerto Sospechoso",
    WebStringKey.ReasonSuspiciousPortDesc to "La URL usa puerto comúnmente asociado con ataques",
    WebStringKey.ReasonFragmentHidingTitle to "Ocultación de Fragmento",
    WebStringKey.ReasonFragmentHidingDesc to "El fragmento de URL parece ocultar contenido adicional",
    WebStringKey.ReasonExcessiveEncodingTitle to "Codificación Excesiva",
    WebStringKey.ReasonExcessiveEncodingDesc to "Codificación de URL excesiva detectada (intento de ofuscación)",
    WebStringKey.ReasonDomainAgePatternTitle to "Patrón de Edad de Dominio",
    WebStringKey.ReasonDomainAgePatternDesc to "El nombre de dominio coincide con patrones de dominios generados automáticamente",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "Acortador de URL",
    WebStringKey.ReasonUrlShortenerDesc to "La URL usa servicio de acortamiento (oculta destino real)",
    WebStringKey.ReasonSuspiciousPathTitle to "Ruta Sospechosa",
    WebStringKey.ReasonSuspiciousPathDesc to "La ruta contiene palabras clave sospechosas (inicio de sesión, verificar, etc.)",
    WebStringKey.ReasonLongUrlTitle to "URL Larga",
    WebStringKey.ReasonLongUrlDesc to "URL inusualmente larga",
    WebStringKey.ReasonCredentialKeywordsTitle to "Palabras Clave de Credenciales",
    WebStringKey.ReasonCredentialKeywordsDesc to "La URL contiene palabras clave de recolección de credenciales",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "URL No Analizable",
    WebStringKey.ReasonUnparseableDesc to "La URL no pudo ser completamente analizada",
    WebStringKey.ReasonAnalysisCompleteTitle to "Análisis Completado",
    WebStringKey.ReasonAnalysisCompleteDesc to "Análisis completado exitosamente",
    
    // ML Score Labels
    WebStringKey.MlPhishingScore to "Puntuación ML de Phishing",
    WebStringKey.MlCharacterAnalysis to "Análisis de caracteres",
    WebStringKey.MlFeatureAnalysis to "Análisis de características",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "Dominio IDN / Punycode",
    WebStringKey.IdnPunycodeDomainDesc to "Este dominio utiliza caracteres internacionalizados. Visualización segura:",
    WebStringKey.MixedScriptAttackTitle to "Ataque de Scripts Mixtos",
    WebStringKey.MixedScriptAttackDesc to "El dominio contiene caracteres de múltiples scripts (ej. Cirílico + Latino). Común en ataques homógrafos.",
    WebStringKey.ConfusableCharsTitle to "Caracteres Confundibles",
    WebStringKey.ConfusableCharsDesc to "El dominio contiene caracteres que se parecen a letras comunes (ej. 'а' vs 'a')."
)
